var items = {
  "block.minecraft.acacia_button": "Pulsante di acacia",
  "block.minecraft.acacia_door": "Porta di acacia",
  "block.minecraft.acacia_fence": "Staccionata di acacia",
  "block.minecraft.acacia_fence_gate": "Cancelletto di acacia",
  "block.minecraft.acacia_hanging_sign": "Insegna di acacia",
  "block.minecraft.acacia_leaves": "Foglie di acacia",
  "block.minecraft.acacia_log": "Tronco di acacia",
  "block.minecraft.acacia_planks": "Assi di acacia",
  "block.minecraft.acacia_pressure_plate": "Pedana a pressione di acacia",
  "block.minecraft.acacia_sapling": "Arboscello di acacia",
  "block.minecraft.acacia_shelf": "Scaffale di acacia",
  "block.minecraft.acacia_sign": "Cartello di acacia",
  "block.minecraft.acacia_slab": "Lastra di acacia",
  "block.minecraft.acacia_stairs": "Scalini di acacia",
  "block.minecraft.acacia_trapdoor": "Botola di acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Insegna di acacia a parete",
  "block.minecraft.acacia_wall_sign": "Cartello di acacia a parete",
  "block.minecraft.acacia_wood": "Legno di acacia",
  "block.minecraft.activator_rail": "Binario attivatore",
  "block.minecraft.air": "Aria",
  "block.minecraft.allium": "Fiore d'aglio",
  "block.minecraft.amethyst_block": "Blocco di ametista",
  "block.minecraft.amethyst_cluster": "Aggregato di ametista",
  "block.minecraft.ancient_debris": "Detriti antichi",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Lastra di andesite",
  "block.minecraft.andesite_stairs": "Scalini di andesite",
  "block.minecraft.andesite_wall": "Muretto di andesite",
  "block.minecraft.anvil": "Incudine",
  "block.minecraft.attached_melon_stem": "Pianta di anguria matura",
  "block.minecraft.attached_pumpkin_stem": "Pianta di zucca matura",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Foglie di azalea",
  "block.minecraft.azure_bluet": "Houstonia",
  "block.minecraft.bamboo": "Bambù",
  "block.minecraft.bamboo_block": "Blocco di bambù",
  "block.minecraft.bamboo_button": "Pulsante di bambù",
  "block.minecraft.bamboo_door": "Porta di bambù",
  "block.minecraft.bamboo_fence": "Staccionata di bambù",
  "block.minecraft.bamboo_fence_gate": "Cancelletto di bambù",
  "block.minecraft.bamboo_hanging_sign": "Insegna di bambù",
  "block.minecraft.bamboo_mosaic": "Bambù intrecciato",
  "block.minecraft.bamboo_mosaic_slab": "Lastra di bambù intrecciato",
  "block.minecraft.bamboo_mosaic_stairs": "Scalini di bambù intrecciato",
  "block.minecraft.bamboo_planks": "Assi di bambù",
  "block.minecraft.bamboo_pressure_plate": "Pedana a pressione di bambù",
  "block.minecraft.bamboo_sapling": "Germoglio di bambù",
  "block.minecraft.bamboo_shelf": "Scaffale di bambù",
  "block.minecraft.bamboo_sign": "Cartello di bambù",
  "block.minecraft.bamboo_slab": "Lastra di bambù",
  "block.minecraft.bamboo_stairs": "Scalini di bambù",
  "block.minecraft.bamboo_trapdoor": "Botola di bambù",
  "block.minecraft.bamboo_wall_hanging_sign": "Insegna di bambù a parete",
  "block.minecraft.bamboo_wall_sign": "Cartello di bambù a parete",
  "block.minecraft.banner.base.black": "Campo nero",
  "block.minecraft.banner.base.blue": "Campo blu",
  "block.minecraft.banner.base.brown": "Campo marrone",
  "block.minecraft.banner.base.cyan": "Campo ciano",
  "block.minecraft.banner.base.gray": "Campo grigio",
  "block.minecraft.banner.base.green": "Campo verde",
  "block.minecraft.banner.base.light_blue": "Campo azzurro",
  "block.minecraft.banner.base.light_gray": "Campo grigio chiaro",
  "block.minecraft.banner.base.lime": "Campo lime",
  "block.minecraft.banner.base.magenta": "Campo magenta",
  "block.minecraft.banner.base.orange": "Campo arancione",
  "block.minecraft.banner.base.pink": "Campo rosa",
  "block.minecraft.banner.base.purple": "Campo viola",
  "block.minecraft.banner.base.red": "Campo rosso",
  "block.minecraft.banner.base.white": "Campo bianco",
  "block.minecraft.banner.base.yellow": "Campo giallo",
  "block.minecraft.banner.border.black": "Bordura nera",
  "block.minecraft.banner.border.blue": "Bordura blu",
  "block.minecraft.banner.border.brown": "Bordura marrone",
  "block.minecraft.banner.border.cyan": "Bordura ciano",
  "block.minecraft.banner.border.gray": "Bordura grigia",
  "block.minecraft.banner.border.green": "Bordura verde",
  "block.minecraft.banner.border.light_blue": "Bordura azzurra",
  "block.minecraft.banner.border.light_gray": "Bordura grigio chiaro",
  "block.minecraft.banner.border.lime": "Bordura lime",
  "block.minecraft.banner.border.magenta": "Bordura magenta",
  "block.minecraft.banner.border.orange": "Bordura arancione",
  "block.minecraft.banner.border.pink": "Bordura rosa",
  "block.minecraft.banner.border.purple": "Bordura viola",
  "block.minecraft.banner.border.red": "Bordura rossa",
  "block.minecraft.banner.border.white": "Bordura bianca",
  "block.minecraft.banner.border.yellow": "Bordura gialla",
  "block.minecraft.banner.bricks.black": "Seminato di mattoni neri",
  "block.minecraft.banner.bricks.blue": "Seminato di mattoni blu",
  "block.minecraft.banner.bricks.brown": "Seminato di mattoni marroni",
  "block.minecraft.banner.bricks.cyan": "Seminato di mattoni ciano",
  "block.minecraft.banner.bricks.gray": "Seminato di mattoni grigi",
  "block.minecraft.banner.bricks.green": "Seminato di mattoni verdi",
  "block.minecraft.banner.bricks.light_blue": "Seminato di mattoni azzurri",
  "block.minecraft.banner.bricks.light_gray": "Seminato di mattoni grigio chiaro",
  "block.minecraft.banner.bricks.lime": "Seminato di mattoni lime",
  "block.minecraft.banner.bricks.magenta": "Seminato di mattoni magenta",
  "block.minecraft.banner.bricks.orange": "Seminato di mattoni arancioni",
  "block.minecraft.banner.bricks.pink": "Seminato di mattoni rosa",
  "block.minecraft.banner.bricks.purple": "Seminato di mattoni viola",
  "block.minecraft.banner.bricks.red": "Seminato di mattoni rossi",
  "block.minecraft.banner.bricks.white": "Seminato di mattoni bianchi",
  "block.minecraft.banner.bricks.yellow": "Seminato di mattoni gialli",
  "block.minecraft.banner.circle.black": "Torta nera",
  "block.minecraft.banner.circle.blue": "Torta blu",
  "block.minecraft.banner.circle.brown": "Torta marrone",
  "block.minecraft.banner.circle.cyan": "Torta ciano",
  "block.minecraft.banner.circle.gray": "Torta grigia",
  "block.minecraft.banner.circle.green": "Torta verde",
  "block.minecraft.banner.circle.light_blue": "Torta azzurra",
  "block.minecraft.banner.circle.light_gray": "Torta grigio chiaro",
  "block.minecraft.banner.circle.lime": "Torta lime",
  "block.minecraft.banner.circle.magenta": "Torta magenta",
  "block.minecraft.banner.circle.orange": "Torta arancione",
  "block.minecraft.banner.circle.pink": "Torta rosa",
  "block.minecraft.banner.circle.purple": "Torta viola",
  "block.minecraft.banner.circle.red": "Torta rossa",
  "block.minecraft.banner.circle.white": "Torta bianca",
  "block.minecraft.banner.circle.yellow": "Torta gialla",
  "block.minecraft.banner.creeper.black": "Volto di creeper nero",
  "block.minecraft.banner.creeper.blue": "Volto di creeper blu",
  "block.minecraft.banner.creeper.brown": "Volto di creeper marrone",
  "block.minecraft.banner.creeper.cyan": "Volto di creeper ciano",
  "block.minecraft.banner.creeper.gray": "Volto di creeper grigio",
  "block.minecraft.banner.creeper.green": "Volto di creeper verde",
  "block.minecraft.banner.creeper.light_blue": "Volto di creeper azzurro",
  "block.minecraft.banner.creeper.light_gray": "Volto di creeper grigio chiaro",
  "block.minecraft.banner.creeper.lime": "Volto di creeper lime",
  "block.minecraft.banner.creeper.magenta": "Volto di creeper magenta",
  "block.minecraft.banner.creeper.orange": "Volto di creeper arancione",
  "block.minecraft.banner.creeper.pink": "Volto di creeper rosa",
  "block.minecraft.banner.creeper.purple": "Volto di creeper viola",
  "block.minecraft.banner.creeper.red": "Volto di creeper rosso",
  "block.minecraft.banner.creeper.white": "Volto di creeper bianco",
  "block.minecraft.banner.creeper.yellow": "Volto di creeper giallo",
  "block.minecraft.banner.cross.black": "Decusse nera",
  "block.minecraft.banner.cross.blue": "Decusse blu",
  "block.minecraft.banner.cross.brown": "Decusse marrone",
  "block.minecraft.banner.cross.cyan": "Decusse ciano",
  "block.minecraft.banner.cross.gray": "Decusse grigia",
  "block.minecraft.banner.cross.green": "Decusse verde",
  "block.minecraft.banner.cross.light_blue": "Decusse azzurra",
  "block.minecraft.banner.cross.light_gray": "Decusse grigio chiaro",
  "block.minecraft.banner.cross.lime": "Decusse lime",
  "block.minecraft.banner.cross.magenta": "Decusse magenta",
  "block.minecraft.banner.cross.orange": "Decusse arancione",
  "block.minecraft.banner.cross.pink": "Decusse rosa",
  "block.minecraft.banner.cross.purple": "Decusse viola",
  "block.minecraft.banner.cross.red": "Decusse rossa",
  "block.minecraft.banner.cross.white": "Decusse bianca",
  "block.minecraft.banner.cross.yellow": "Decusse gialla",
  "block.minecraft.banner.curly_border.black": "Bordura dentata nera",
  "block.minecraft.banner.curly_border.blue": "Bordura dentata blu",
  "block.minecraft.banner.curly_border.brown": "Bordura dentata marrone",
  "block.minecraft.banner.curly_border.cyan": "Bordura dentata ciano",
  "block.minecraft.banner.curly_border.gray": "Bordura dentata grigia",
  "block.minecraft.banner.curly_border.green": "Bordura dentata verde",
  "block.minecraft.banner.curly_border.light_blue": "Bordura dentata azzurra",
  "block.minecraft.banner.curly_border.light_gray": "Bordura dentata grigio chiaro",
  "block.minecraft.banner.curly_border.lime": "Bordura dentata lime",
  "block.minecraft.banner.curly_border.magenta": "Bordura dentata magenta",
  "block.minecraft.banner.curly_border.orange": "Bordura dentata arancione",
  "block.minecraft.banner.curly_border.pink": "Bordura dentata rosa",
  "block.minecraft.banner.curly_border.purple": "Bordura dentata viola",
  "block.minecraft.banner.curly_border.red": "Bordura dentata rossa",
  "block.minecraft.banner.curly_border.white": "Bordura dentata bianca",
  "block.minecraft.banner.curly_border.yellow": "Bordura dentata gialla",
  "block.minecraft.banner.diagonal_left.black": "Tagliato nero",
  "block.minecraft.banner.diagonal_left.blue": "Tagliato blu",
  "block.minecraft.banner.diagonal_left.brown": "Tagliato marrone",
  "block.minecraft.banner.diagonal_left.cyan": "Tagliato ciano",
  "block.minecraft.banner.diagonal_left.gray": "Tagliato grigio",
  "block.minecraft.banner.diagonal_left.green": "Tagliato verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Tagliato azzurro",
  "block.minecraft.banner.diagonal_left.light_gray": "Tagliato grigio chiaro",
  "block.minecraft.banner.diagonal_left.lime": "Tagliato lime",
  "block.minecraft.banner.diagonal_left.magenta": "Tagliato magenta",
  "block.minecraft.banner.diagonal_left.orange": "Tagliato arancione",
  "block.minecraft.banner.diagonal_left.pink": "Tagliato rosa",
  "block.minecraft.banner.diagonal_left.purple": "Tagliato viola",
  "block.minecraft.banner.diagonal_left.red": "Tagliato rosso",
  "block.minecraft.banner.diagonal_left.white": "Tagliato bianco",
  "block.minecraft.banner.diagonal_left.yellow": "Tagliato giallo",
  "block.minecraft.banner.diagonal_right.black": "Trinciato nero",
  "block.minecraft.banner.diagonal_right.blue": "Trinciato blu",
  "block.minecraft.banner.diagonal_right.brown": "Trinciato marrone",
  "block.minecraft.banner.diagonal_right.cyan": "Trinciato ciano",
  "block.minecraft.banner.diagonal_right.gray": "Trinciato grigio",
  "block.minecraft.banner.diagonal_right.green": "Trinciato verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Trinciato azzurro",
  "block.minecraft.banner.diagonal_right.light_gray": "Trinciato grigio chiaro",
  "block.minecraft.banner.diagonal_right.lime": "Trinciato lime",
  "block.minecraft.banner.diagonal_right.magenta": "Trinciato magenta",
  "block.minecraft.banner.diagonal_right.orange": "Trinciato arancione",
  "block.minecraft.banner.diagonal_right.pink": "Trinciato rosa",
  "block.minecraft.banner.diagonal_right.purple": "Trinciato viola",
  "block.minecraft.banner.diagonal_right.red": "Trinciato rosso",
  "block.minecraft.banner.diagonal_right.white": "Trinciato bianco",
  "block.minecraft.banner.diagonal_right.yellow": "Trinciato giallo",
  "block.minecraft.banner.diagonal_up_left.black": "Trinciato rovesciato nero",
  "block.minecraft.banner.diagonal_up_left.blue": "Trinciato rovesciato blu",
  "block.minecraft.banner.diagonal_up_left.brown": "Trinciato rovesciato marrone",
  "block.minecraft.banner.diagonal_up_left.cyan": "Trinciato rovesciato ciano",
  "block.minecraft.banner.diagonal_up_left.gray": "Trinciato rovesciato grigio",
  "block.minecraft.banner.diagonal_up_left.green": "Trinciato rovesciato verde",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Trinciato rovesciato azzurro",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Trinciato rovesciato grigio chiaro",
  "block.minecraft.banner.diagonal_up_left.lime": "Trinciato rovesciato lime",
  "block.minecraft.banner.diagonal_up_left.magenta": "Trinciato rovesciato magenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Trinciato rovesciato arancione",
  "block.minecraft.banner.diagonal_up_left.pink": "Trinciato rovesciato rosa",
  "block.minecraft.banner.diagonal_up_left.purple": "Trinciato rovesciato viola",
  "block.minecraft.banner.diagonal_up_left.red": "Trinciato rovesciato rosso",
  "block.minecraft.banner.diagonal_up_left.white": "Trinciato rovesciato bianco",
  "block.minecraft.banner.diagonal_up_left.yellow": "Trinciato rovesciato giallo",
  "block.minecraft.banner.diagonal_up_right.black": "Tagliato rovesciato nero",
  "block.minecraft.banner.diagonal_up_right.blue": "Tagliato rovesciato blu",
  "block.minecraft.banner.diagonal_up_right.brown": "Tagliato rovesciato marrone",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tagliato rovesciato ciano",
  "block.minecraft.banner.diagonal_up_right.gray": "Tagliato rovesciato grigio",
  "block.minecraft.banner.diagonal_up_right.green": "Tagliato rovesciato verde",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tagliato rovesciato azzurro",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tagliato rovesciato grigio chiaro",
  "block.minecraft.banner.diagonal_up_right.lime": "Tagliato rovesciato lime",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tagliato rovesciato magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Tagliato rovesciato arancione",
  "block.minecraft.banner.diagonal_up_right.pink": "Tagliato rovesciato rosa",
  "block.minecraft.banner.diagonal_up_right.purple": "Tagliato rovesciato viola",
  "block.minecraft.banner.diagonal_up_right.red": "Tagliato rovesciato rosso",
  "block.minecraft.banner.diagonal_up_right.white": "Tagliato rovesciato bianco",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tagliato rovesciato giallo",
  "block.minecraft.banner.flow.black": "Flusso nero",
  "block.minecraft.banner.flow.blue": "Flusso blu",
  "block.minecraft.banner.flow.brown": "Flusso marrone",
  "block.minecraft.banner.flow.cyan": "Flusso ciano",
  "block.minecraft.banner.flow.gray": "Flusso grigio",
  "block.minecraft.banner.flow.green": "Flusso verde",
  "block.minecraft.banner.flow.light_blue": "Flusso azzurro",
  "block.minecraft.banner.flow.light_gray": "Flusso grigio chiaro",
  "block.minecraft.banner.flow.lime": "Flusso lime",
  "block.minecraft.banner.flow.magenta": "Flusso magenta",
  "block.minecraft.banner.flow.orange": "Flusso arancione",
  "block.minecraft.banner.flow.pink": "Flusso rosa",
  "block.minecraft.banner.flow.purple": "Flusso viola",
  "block.minecraft.banner.flow.red": "Flusso rosso",
  "block.minecraft.banner.flow.white": "Flusso bianco",
  "block.minecraft.banner.flow.yellow": "Flusso giallo",
  "block.minecraft.banner.flower.black": "Fiore nero",
  "block.minecraft.banner.flower.blue": "Fiore blu",
  "block.minecraft.banner.flower.brown": "Fiore marrone",
  "block.minecraft.banner.flower.cyan": "Fiore ciano",
  "block.minecraft.banner.flower.gray": "Fiore grigio",
  "block.minecraft.banner.flower.green": "Fiore verde",
  "block.minecraft.banner.flower.light_blue": "Fiore azzurro",
  "block.minecraft.banner.flower.light_gray": "Fiore grigio chiaro",
  "block.minecraft.banner.flower.lime": "Fiore lime",
  "block.minecraft.banner.flower.magenta": "Fiore magenta",
  "block.minecraft.banner.flower.orange": "Fiore arancione",
  "block.minecraft.banner.flower.pink": "Fiore rosa",
  "block.minecraft.banner.flower.purple": "Fiore viola",
  "block.minecraft.banner.flower.red": "Fiore rosso",
  "block.minecraft.banner.flower.white": "Fiore bianco",
  "block.minecraft.banner.flower.yellow": "Fiore giallo",
  "block.minecraft.banner.globe.black": "Globo nero",
  "block.minecraft.banner.globe.blue": "Globo blu",
  "block.minecraft.banner.globe.brown": "Globo marrone",
  "block.minecraft.banner.globe.cyan": "Globo ciano",
  "block.minecraft.banner.globe.gray": "Globo grigio",
  "block.minecraft.banner.globe.green": "Globo verde",
  "block.minecraft.banner.globe.light_blue": "Globo azzurro",
  "block.minecraft.banner.globe.light_gray": "Globo grigio chiaro",
  "block.minecraft.banner.globe.lime": "Globo lime",
  "block.minecraft.banner.globe.magenta": "Globo magenta",
  "block.minecraft.banner.globe.orange": "Globo arancione",
  "block.minecraft.banner.globe.pink": "Globo rosa",
  "block.minecraft.banner.globe.purple": "Globo viola",
  "block.minecraft.banner.globe.red": "Globo rosso",
  "block.minecraft.banner.globe.white": "Globo bianco",
  "block.minecraft.banner.globe.yellow": "Globo giallo",
  "block.minecraft.banner.gradient.black": "Sfumatura in capo nera",
  "block.minecraft.banner.gradient.blue": "Sfumatura in capo blu",
  "block.minecraft.banner.gradient.brown": "Sfumatura in capo marrone",
  "block.minecraft.banner.gradient.cyan": "Sfumatura in capo ciano",
  "block.minecraft.banner.gradient.gray": "Sfumatura in capo grigia",
  "block.minecraft.banner.gradient.green": "Sfumatura in capo verde",
  "block.minecraft.banner.gradient.light_blue": "Sfumatura in capo azzurra",
  "block.minecraft.banner.gradient.light_gray": "Sfumatura in capo grigio chiaro",
  "block.minecraft.banner.gradient.lime": "Sfumatura in capo lime",
  "block.minecraft.banner.gradient.magenta": "Sfumatura in capo magenta",
  "block.minecraft.banner.gradient.orange": "Sfumatura in capo arancione",
  "block.minecraft.banner.gradient.pink": "Sfumatura in capo rosa",
  "block.minecraft.banner.gradient.purple": "Sfumatura in capo viola",
  "block.minecraft.banner.gradient.red": "Sfumatura in capo rossa",
  "block.minecraft.banner.gradient.white": "Sfumatura in capo bianca",
  "block.minecraft.banner.gradient.yellow": "Sfumatura in capo gialla",
  "block.minecraft.banner.gradient_up.black": "Sfumatura in punta nera",
  "block.minecraft.banner.gradient_up.blue": "Sfumatura in punta blu",
  "block.minecraft.banner.gradient_up.brown": "Sfumatura in punta marrone",
  "block.minecraft.banner.gradient_up.cyan": "Sfumatura in punta ciano",
  "block.minecraft.banner.gradient_up.gray": "Sfumatura in punta grigia",
  "block.minecraft.banner.gradient_up.green": "Sfumatura in punta verde",
  "block.minecraft.banner.gradient_up.light_blue": "Sfumatura in punta azzurra",
  "block.minecraft.banner.gradient_up.light_gray": "Sfumatura in punta grigio chiaro",
  "block.minecraft.banner.gradient_up.lime": "Sfumatura in punta lime",
  "block.minecraft.banner.gradient_up.magenta": "Sfumatura in punta magenta",
  "block.minecraft.banner.gradient_up.orange": "Sfumatura in punta arancione",
  "block.minecraft.banner.gradient_up.pink": "Sfumatura in punta rosa",
  "block.minecraft.banner.gradient_up.purple": "Sfumatura in punta viola",
  "block.minecraft.banner.gradient_up.red": "Sfumatura in punta rossa",
  "block.minecraft.banner.gradient_up.white": "Sfumatura in punta bianca",
  "block.minecraft.banner.gradient_up.yellow": "Sfumatura in punta gialla",
  "block.minecraft.banner.guster.black": "Raffica nera",
  "block.minecraft.banner.guster.blue": "Raffica blu",
  "block.minecraft.banner.guster.brown": "Raffica marrone",
  "block.minecraft.banner.guster.cyan": "Raffica ciano",
  "block.minecraft.banner.guster.gray": "Raffica grigia",
  "block.minecraft.banner.guster.green": "Raffica verde",
  "block.minecraft.banner.guster.light_blue": "Raffica azzurra",
  "block.minecraft.banner.guster.light_gray": "Raffica grigio chiaro",
  "block.minecraft.banner.guster.lime": "Raffica lime",
  "block.minecraft.banner.guster.magenta": "Raffica magenta",
  "block.minecraft.banner.guster.orange": "Raffica arancione",
  "block.minecraft.banner.guster.pink": "Raffica rosa",
  "block.minecraft.banner.guster.purple": "Raffica viola",
  "block.minecraft.banner.guster.red": "Raffica rossa",
  "block.minecraft.banner.guster.white": "Raffica bianca",
  "block.minecraft.banner.guster.yellow": "Raffica gialla",
  "block.minecraft.banner.half_horizontal.black": "Troncato nero",
  "block.minecraft.banner.half_horizontal.blue": "Troncato blu",
  "block.minecraft.banner.half_horizontal.brown": "Troncato marrone",
  "block.minecraft.banner.half_horizontal.cyan": "Troncato ciano",
  "block.minecraft.banner.half_horizontal.gray": "Troncato grigio",
  "block.minecraft.banner.half_horizontal.green": "Troncato verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Troncato azzurro",
  "block.minecraft.banner.half_horizontal.light_gray": "Troncato grigio chiaro",
  "block.minecraft.banner.half_horizontal.lime": "Troncato lime",
  "block.minecraft.banner.half_horizontal.magenta": "Troncato magenta",
  "block.minecraft.banner.half_horizontal.orange": "Troncato arancione",
  "block.minecraft.banner.half_horizontal.pink": "Troncato rosa",
  "block.minecraft.banner.half_horizontal.purple": "Troncato viola",
  "block.minecraft.banner.half_horizontal.red": "Troncato rosso",
  "block.minecraft.banner.half_horizontal.white": "Troncato bianco",
  "block.minecraft.banner.half_horizontal.yellow": "Troncato giallo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Troncato rovesciato nero",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Troncato rovesciato blu",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Troncato rovesciato marrone",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Troncato rovesciato ciano",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Troncato rovesciato grigio",
  "block.minecraft.banner.half_horizontal_bottom.green": "Troncato rovesciato verde",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Troncato rovesciato azzurro",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Troncato rovesciato grigio chiaro",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Troncato rovesciato lime",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Troncato rovesciato magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Troncato rovesciato arancione",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Troncato rovesciato rosa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Troncato rovesciato viola",
  "block.minecraft.banner.half_horizontal_bottom.red": "Troncato rovesciato rosso",
  "block.minecraft.banner.half_horizontal_bottom.white": "Troncato rovesciato bianco",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Troncato rovesciato giallo",
  "block.minecraft.banner.half_vertical.black": "Partito nero",
  "block.minecraft.banner.half_vertical.blue": "Partito blu",
  "block.minecraft.banner.half_vertical.brown": "Partito marrone",
  "block.minecraft.banner.half_vertical.cyan": "Partito ciano",
  "block.minecraft.banner.half_vertical.gray": "Partito grigio",
  "block.minecraft.banner.half_vertical.green": "Partito verde",
  "block.minecraft.banner.half_vertical.light_blue": "Partito azzurro",
  "block.minecraft.banner.half_vertical.light_gray": "Partito grigio chiaro",
  "block.minecraft.banner.half_vertical.lime": "Partito lime",
  "block.minecraft.banner.half_vertical.magenta": "Partito magenta",
  "block.minecraft.banner.half_vertical.orange": "Partito arancione",
  "block.minecraft.banner.half_vertical.pink": "Partito rosa",
  "block.minecraft.banner.half_vertical.purple": "Partito viola",
  "block.minecraft.banner.half_vertical.red": "Partito rosso",
  "block.minecraft.banner.half_vertical.white": "Partito bianco",
  "block.minecraft.banner.half_vertical.yellow": "Partito giallo",
  "block.minecraft.banner.half_vertical_right.black": "Partito rivoltato nero",
  "block.minecraft.banner.half_vertical_right.blue": "Partito rivoltato blu",
  "block.minecraft.banner.half_vertical_right.brown": "Partito rivoltato marrone",
  "block.minecraft.banner.half_vertical_right.cyan": "Partito rivoltato ciano",
  "block.minecraft.banner.half_vertical_right.gray": "Partito rivoltato grigio",
  "block.minecraft.banner.half_vertical_right.green": "Partito rivoltato verde",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partito rivoltato azzurro",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partito rivoltato grigio chiaro",
  "block.minecraft.banner.half_vertical_right.lime": "Partito rivoltato lime",
  "block.minecraft.banner.half_vertical_right.magenta": "Partito rivoltato magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Partito rivoltato arancione",
  "block.minecraft.banner.half_vertical_right.pink": "Partito rivoltato rosa",
  "block.minecraft.banner.half_vertical_right.purple": "Partito rivoltato viola",
  "block.minecraft.banner.half_vertical_right.red": "Partito rivoltato rosso",
  "block.minecraft.banner.half_vertical_right.white": "Partito rivoltato bianco",
  "block.minecraft.banner.half_vertical_right.yellow": "Partito rivoltato giallo",
  "block.minecraft.banner.mojang.black": "Logo nero",
  "block.minecraft.banner.mojang.blue": "Logo blu",
  "block.minecraft.banner.mojang.brown": "Logo marrone",
  "block.minecraft.banner.mojang.cyan": "Logo ciano",
  "block.minecraft.banner.mojang.gray": "Logo grigio",
  "block.minecraft.banner.mojang.green": "Logo verde",
  "block.minecraft.banner.mojang.light_blue": "Logo azzurro",
  "block.minecraft.banner.mojang.light_gray": "Logo grigio chiaro",
  "block.minecraft.banner.mojang.lime": "Logo lime",
  "block.minecraft.banner.mojang.magenta": "Logo magenta",
  "block.minecraft.banner.mojang.orange": "Logo arancione",
  "block.minecraft.banner.mojang.pink": "Logo rosa",
  "block.minecraft.banner.mojang.purple": "Logo viola",
  "block.minecraft.banner.mojang.red": "Logo rosso",
  "block.minecraft.banner.mojang.white": "Logo bianco",
  "block.minecraft.banner.mojang.yellow": "Logo giallo",
  "block.minecraft.banner.piglin.black": "Grugno nero",
  "block.minecraft.banner.piglin.blue": "Grugno blu",
  "block.minecraft.banner.piglin.brown": "Grugno marrone",
  "block.minecraft.banner.piglin.cyan": "Grugno ciano",
  "block.minecraft.banner.piglin.gray": "Grugno grigio",
  "block.minecraft.banner.piglin.green": "Grugno verde",
  "block.minecraft.banner.piglin.light_blue": "Grugno azzurro",
  "block.minecraft.banner.piglin.light_gray": "Grugno grigio chiaro",
  "block.minecraft.banner.piglin.lime": "Grugno lime",
  "block.minecraft.banner.piglin.magenta": "Grugno magenta",
  "block.minecraft.banner.piglin.orange": "Grugno arancione",
  "block.minecraft.banner.piglin.pink": "Grugno rosa",
  "block.minecraft.banner.piglin.purple": "Grugno viola",
  "block.minecraft.banner.piglin.red": "Grugno rosso",
  "block.minecraft.banner.piglin.white": "Grugno bianco",
  "block.minecraft.banner.piglin.yellow": "Grugno giallo",
  "block.minecraft.banner.rhombus.black": "Losanga nera",
  "block.minecraft.banner.rhombus.blue": "Losanga blu",
  "block.minecraft.banner.rhombus.brown": "Losanga marrone",
  "block.minecraft.banner.rhombus.cyan": "Losanga ciano",
  "block.minecraft.banner.rhombus.gray": "Losanga grigia",
  "block.minecraft.banner.rhombus.green": "Losanga verde",
  "block.minecraft.banner.rhombus.light_blue": "Losanga azzurra",
  "block.minecraft.banner.rhombus.light_gray": "Losanga grigio chiaro",
  "block.minecraft.banner.rhombus.lime": "Losanga lime",
  "block.minecraft.banner.rhombus.magenta": "Losanga magenta",
  "block.minecraft.banner.rhombus.orange": "Losanga arancione",
  "block.minecraft.banner.rhombus.pink": "Losanga rosa",
  "block.minecraft.banner.rhombus.purple": "Losanga viola",
  "block.minecraft.banner.rhombus.red": "Losanga rossa",
  "block.minecraft.banner.rhombus.white": "Losanga bianca",
  "block.minecraft.banner.rhombus.yellow": "Losanga gialla",
  "block.minecraft.banner.skull.black": "Teschio nero",
  "block.minecraft.banner.skull.blue": "Teschio blu",
  "block.minecraft.banner.skull.brown": "Teschio marrone",
  "block.minecraft.banner.skull.cyan": "Teschio ciano",
  "block.minecraft.banner.skull.gray": "Teschio grigio",
  "block.minecraft.banner.skull.green": "Teschio verde",
  "block.minecraft.banner.skull.light_blue": "Teschio azzurro",
  "block.minecraft.banner.skull.light_gray": "Teschio grigio chiaro",
  "block.minecraft.banner.skull.lime": "Teschio lime",
  "block.minecraft.banner.skull.magenta": "Teschio magenta",
  "block.minecraft.banner.skull.orange": "Teschio arancione",
  "block.minecraft.banner.skull.pink": "Teschio rosa",
  "block.minecraft.banner.skull.purple": "Teschio viola",
  "block.minecraft.banner.skull.red": "Teschio rosso",
  "block.minecraft.banner.skull.white": "Teschio bianco",
  "block.minecraft.banner.skull.yellow": "Teschio giallo",
  "block.minecraft.banner.small_stripes.black": "Palato nero",
  "block.minecraft.banner.small_stripes.blue": "Palato blu",
  "block.minecraft.banner.small_stripes.brown": "Palato marrone",
  "block.minecraft.banner.small_stripes.cyan": "Palato ciano",
  "block.minecraft.banner.small_stripes.gray": "Palato grigio",
  "block.minecraft.banner.small_stripes.green": "Palato verde",
  "block.minecraft.banner.small_stripes.light_blue": "Palato azzurro",
  "block.minecraft.banner.small_stripes.light_gray": "Palato grigio chiaro",
  "block.minecraft.banner.small_stripes.lime": "Palato lime",
  "block.minecraft.banner.small_stripes.magenta": "Palato magenta",
  "block.minecraft.banner.small_stripes.orange": "Palato arancione",
  "block.minecraft.banner.small_stripes.pink": "Palato rosa",
  "block.minecraft.banner.small_stripes.purple": "Palato viola",
  "block.minecraft.banner.small_stripes.red": "Palato rosso",
  "block.minecraft.banner.small_stripes.white": "Palato bianco",
  "block.minecraft.banner.small_stripes.yellow": "Palato giallo",
  "block.minecraft.banner.square_bottom_left.black": "Cantone destro della punta nero",
  "block.minecraft.banner.square_bottom_left.blue": "Cantone destro della punta blu",
  "block.minecraft.banner.square_bottom_left.brown": "Cantone destro della punta marrone",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantone destro della punta ciano",
  "block.minecraft.banner.square_bottom_left.gray": "Cantone destro della punta grigio",
  "block.minecraft.banner.square_bottom_left.green": "Cantone destro della punta verde",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantone destro della punta azzurro",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantone destro della punta grigio chiaro",
  "block.minecraft.banner.square_bottom_left.lime": "Cantone destro della punta lime",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantone destro della punta magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Cantone destro della punta arancione",
  "block.minecraft.banner.square_bottom_left.pink": "Cantone destro della punta rosa",
  "block.minecraft.banner.square_bottom_left.purple": "Cantone destro della punta viola",
  "block.minecraft.banner.square_bottom_left.red": "Cantone destro della punta rosso",
  "block.minecraft.banner.square_bottom_left.white": "Cantone destro della punta bianco",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantone destro della punta giallo",
  "block.minecraft.banner.square_bottom_right.black": "Cantone sinistro della punta nero",
  "block.minecraft.banner.square_bottom_right.blue": "Cantone sinistro della punta blu",
  "block.minecraft.banner.square_bottom_right.brown": "Cantone sinistro della punta marrone",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantone sinistro della punta ciano",
  "block.minecraft.banner.square_bottom_right.gray": "Cantone sinistro della punta grigio",
  "block.minecraft.banner.square_bottom_right.green": "Cantone sinistro della punta verde",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantone sinistro della punta azzurro",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantone sinistro della punta grigio chiaro",
  "block.minecraft.banner.square_bottom_right.lime": "Cantone sinistro della punta lime",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantone sinistro della punta magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Cantone sinistro della punta arancione",
  "block.minecraft.banner.square_bottom_right.pink": "Cantone sinistro della punta rosa",
  "block.minecraft.banner.square_bottom_right.purple": "Cantone sinistro della punta viola",
  "block.minecraft.banner.square_bottom_right.red": "Cantone sinistro della punta rosso",
  "block.minecraft.banner.square_bottom_right.white": "Cantone sinistro della punta bianco",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantone sinistro della punta giallo",
  "block.minecraft.banner.square_top_left.black": "Cantone destro del capo nero",
  "block.minecraft.banner.square_top_left.blue": "Cantone destro del capo blu",
  "block.minecraft.banner.square_top_left.brown": "Cantone destro del capo marrone",
  "block.minecraft.banner.square_top_left.cyan": "Cantone destro del capo ciano",
  "block.minecraft.banner.square_top_left.gray": "Cantone destro del capo grigio",
  "block.minecraft.banner.square_top_left.green": "Cantone destro del capo verde",
  "block.minecraft.banner.square_top_left.light_blue": "Cantone destro del capo azzurro",
  "block.minecraft.banner.square_top_left.light_gray": "Cantone destro del capo grigio chiaro",
  "block.minecraft.banner.square_top_left.lime": "Cantone destro del capo lime",
  "block.minecraft.banner.square_top_left.magenta": "Cantone destro del capo magenta",
  "block.minecraft.banner.square_top_left.orange": "Cantone destro del capo arancione",
  "block.minecraft.banner.square_top_left.pink": "Cantone destro del capo rosa",
  "block.minecraft.banner.square_top_left.purple": "Cantone destro del capo viola",
  "block.minecraft.banner.square_top_left.red": "Cantone destro del capo rosso",
  "block.minecraft.banner.square_top_left.white": "Cantone destro del capo bianco",
  "block.minecraft.banner.square_top_left.yellow": "Cantone destro del capo giallo",
  "block.minecraft.banner.square_top_right.black": "Cantone sinistro del capo nero",
  "block.minecraft.banner.square_top_right.blue": "Cantone sinistro del capo blu",
  "block.minecraft.banner.square_top_right.brown": "Cantone sinistro del capo marrone",
  "block.minecraft.banner.square_top_right.cyan": "Cantone sinistro del capo ciano",
  "block.minecraft.banner.square_top_right.gray": "Cantone sinistro del capo grigio",
  "block.minecraft.banner.square_top_right.green": "Cantone sinistro del capo verde",
  "block.minecraft.banner.square_top_right.light_blue": "Cantone sinistro del capo azzurro",
  "block.minecraft.banner.square_top_right.light_gray": "Cantone sinistro del capo grigio chiaro",
  "block.minecraft.banner.square_top_right.lime": "Cantone sinistro del capo lime",
  "block.minecraft.banner.square_top_right.magenta": "Cantone sinistro del capo magenta",
  "block.minecraft.banner.square_top_right.orange": "Cantone sinistro del capo arancione",
  "block.minecraft.banner.square_top_right.pink": "Cantone sinistro del capo rosa",
  "block.minecraft.banner.square_top_right.purple": "Cantone sinistro del capo viola",
  "block.minecraft.banner.square_top_right.red": "Cantone sinistro del capo rosso",
  "block.minecraft.banner.square_top_right.white": "Cantone sinistro del capo bianco",
  "block.minecraft.banner.square_top_right.yellow": "Cantone sinistro del capo giallo",
  "block.minecraft.banner.straight_cross.black": "Croce nera",
  "block.minecraft.banner.straight_cross.blue": "Croce blu",
  "block.minecraft.banner.straight_cross.brown": "Croce marrone",
  "block.minecraft.banner.straight_cross.cyan": "Croce ciano",
  "block.minecraft.banner.straight_cross.gray": "Croce grigia",
  "block.minecraft.banner.straight_cross.green": "Croce verde",
  "block.minecraft.banner.straight_cross.light_blue": "Croce azzurra",
  "block.minecraft.banner.straight_cross.light_gray": "Croce grigio chiaro",
  "block.minecraft.banner.straight_cross.lime": "Croce lime",
  "block.minecraft.banner.straight_cross.magenta": "Croce magenta",
  "block.minecraft.banner.straight_cross.orange": "Croce arancione",
  "block.minecraft.banner.straight_cross.pink": "Croce rosa",
  "block.minecraft.banner.straight_cross.purple": "Croce viola",
  "block.minecraft.banner.straight_cross.red": "Croce rossa",
  "block.minecraft.banner.straight_cross.white": "Croce bianca",
  "block.minecraft.banner.straight_cross.yellow": "Croce gialla",
  "block.minecraft.banner.stripe_bottom.black": "Fascia in punta nera",
  "block.minecraft.banner.stripe_bottom.blue": "Fascia in punta blu",
  "block.minecraft.banner.stripe_bottom.brown": "Fascia in punta marrone",
  "block.minecraft.banner.stripe_bottom.cyan": "Fascia in punta ciano",
  "block.minecraft.banner.stripe_bottom.gray": "Fascia in punta grigia",
  "block.minecraft.banner.stripe_bottom.green": "Fascia in punta verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Fascia in punta azzurra",
  "block.minecraft.banner.stripe_bottom.light_gray": "Fascia in punta grigio chiaro",
  "block.minecraft.banner.stripe_bottom.lime": "Fascia in punta lime",
  "block.minecraft.banner.stripe_bottom.magenta": "Fascia in punta magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Fascia in punta arancione",
  "block.minecraft.banner.stripe_bottom.pink": "Fascia in punta rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Fascia in punta viola",
  "block.minecraft.banner.stripe_bottom.red": "Fascia in punta rossa",
  "block.minecraft.banner.stripe_bottom.white": "Fascia in punta bianca",
  "block.minecraft.banner.stripe_bottom.yellow": "Fascia in punta gialla",
  "block.minecraft.banner.stripe_center.black": "Palo nero",
  "block.minecraft.banner.stripe_center.blue": "Palo blu",
  "block.minecraft.banner.stripe_center.brown": "Palo marrone",
  "block.minecraft.banner.stripe_center.cyan": "Palo ciano",
  "block.minecraft.banner.stripe_center.gray": "Palo grigio",
  "block.minecraft.banner.stripe_center.green": "Palo verde",
  "block.minecraft.banner.stripe_center.light_blue": "Palo azzurro",
  "block.minecraft.banner.stripe_center.light_gray": "Palo grigio chiaro",
  "block.minecraft.banner.stripe_center.lime": "Palo lime",
  "block.minecraft.banner.stripe_center.magenta": "Palo magenta",
  "block.minecraft.banner.stripe_center.orange": "Palo arancione",
  "block.minecraft.banner.stripe_center.pink": "Palo rosa",
  "block.minecraft.banner.stripe_center.purple": "Palo viola",
  "block.minecraft.banner.stripe_center.red": "Palo rosso",
  "block.minecraft.banner.stripe_center.white": "Palo bianco",
  "block.minecraft.banner.stripe_center.yellow": "Palo giallo",
  "block.minecraft.banner.stripe_downleft.black": "Sbarra nera",
  "block.minecraft.banner.stripe_downleft.blue": "Sbarra blu",
  "block.minecraft.banner.stripe_downleft.brown": "Sbarra marrone",
  "block.minecraft.banner.stripe_downleft.cyan": "Sbarra ciano",
  "block.minecraft.banner.stripe_downleft.gray": "Sbarra grigia",
  "block.minecraft.banner.stripe_downleft.green": "Sbarra verde",
  "block.minecraft.banner.stripe_downleft.light_blue": "Sbarra azzurra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Sbarra grigio chiaro",
  "block.minecraft.banner.stripe_downleft.lime": "Sbarra lime",
  "block.minecraft.banner.stripe_downleft.magenta": "Sbarra magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Sbarra arancione",
  "block.minecraft.banner.stripe_downleft.pink": "Sbarra rosa",
  "block.minecraft.banner.stripe_downleft.purple": "Sbarra viola",
  "block.minecraft.banner.stripe_downleft.red": "Sbarra rossa",
  "block.minecraft.banner.stripe_downleft.white": "Sbarra bianca",
  "block.minecraft.banner.stripe_downleft.yellow": "Sbarra gialla",
  "block.minecraft.banner.stripe_downright.black": "Banda nera",
  "block.minecraft.banner.stripe_downright.blue": "Banda blu",
  "block.minecraft.banner.stripe_downright.brown": "Banda marrone",
  "block.minecraft.banner.stripe_downright.cyan": "Banda ciano",
  "block.minecraft.banner.stripe_downright.gray": "Banda grigia",
  "block.minecraft.banner.stripe_downright.green": "Banda verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda azzurra",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda grigio chiaro",
  "block.minecraft.banner.stripe_downright.lime": "Banda lime",
  "block.minecraft.banner.stripe_downright.magenta": "Banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda arancione",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda viola",
  "block.minecraft.banner.stripe_downright.red": "Banda rossa",
  "block.minecraft.banner.stripe_downright.white": "Banda bianca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda gialla",
  "block.minecraft.banner.stripe_left.black": "Palo destro nero",
  "block.minecraft.banner.stripe_left.blue": "Palo destro blu",
  "block.minecraft.banner.stripe_left.brown": "Palo destro marrone",
  "block.minecraft.banner.stripe_left.cyan": "Palo destro ciano",
  "block.minecraft.banner.stripe_left.gray": "Palo destro grigio",
  "block.minecraft.banner.stripe_left.green": "Palo destro verde",
  "block.minecraft.banner.stripe_left.light_blue": "Palo destro azzurro",
  "block.minecraft.banner.stripe_left.light_gray": "Palo destro grigio chiaro",
  "block.minecraft.banner.stripe_left.lime": "Palo destro lime",
  "block.minecraft.banner.stripe_left.magenta": "Palo destro magenta",
  "block.minecraft.banner.stripe_left.orange": "Palo destro arancione",
  "block.minecraft.banner.stripe_left.pink": "Palo destro rosa",
  "block.minecraft.banner.stripe_left.purple": "Palo destro viola",
  "block.minecraft.banner.stripe_left.red": "Palo destro rosso",
  "block.minecraft.banner.stripe_left.white": "Palo destro bianco",
  "block.minecraft.banner.stripe_left.yellow": "Palo destro giallo",
  "block.minecraft.banner.stripe_middle.black": "Fascia nera",
  "block.minecraft.banner.stripe_middle.blue": "Fascia blu",
  "block.minecraft.banner.stripe_middle.brown": "Fascia marrone",
  "block.minecraft.banner.stripe_middle.cyan": "Fascia ciano",
  "block.minecraft.banner.stripe_middle.gray": "Fascia grigia",
  "block.minecraft.banner.stripe_middle.green": "Fascia verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Fascia azzurra",
  "block.minecraft.banner.stripe_middle.light_gray": "Fascia grigio chiaro",
  "block.minecraft.banner.stripe_middle.lime": "Fascia lime",
  "block.minecraft.banner.stripe_middle.magenta": "Fascia magenta",
  "block.minecraft.banner.stripe_middle.orange": "Fascia arancione",
  "block.minecraft.banner.stripe_middle.pink": "Fascia rosa",
  "block.minecraft.banner.stripe_middle.purple": "Fascia viola",
  "block.minecraft.banner.stripe_middle.red": "Fascia rossa",
  "block.minecraft.banner.stripe_middle.white": "Fascia bianca",
  "block.minecraft.banner.stripe_middle.yellow": "Fascia gialla",
  "block.minecraft.banner.stripe_right.black": "Palo sinistro nero",
  "block.minecraft.banner.stripe_right.blue": "Palo sinistro blu",
  "block.minecraft.banner.stripe_right.brown": "Palo sinistro marrone",
  "block.minecraft.banner.stripe_right.cyan": "Palo sinistro ciano",
  "block.minecraft.banner.stripe_right.gray": "Palo sinistro grigio",
  "block.minecraft.banner.stripe_right.green": "Palo sinistro verde",
  "block.minecraft.banner.stripe_right.light_blue": "Palo sinistro azzurro",
  "block.minecraft.banner.stripe_right.light_gray": "Palo sinistro grigio chiaro",
  "block.minecraft.banner.stripe_right.lime": "Palo sinistro lime",
  "block.minecraft.banner.stripe_right.magenta": "Palo sinistro magenta",
  "block.minecraft.banner.stripe_right.orange": "Palo sinistro arancione",
  "block.minecraft.banner.stripe_right.pink": "Palo sinistro rosa",
  "block.minecraft.banner.stripe_right.purple": "Palo sinistro viola",
  "block.minecraft.banner.stripe_right.red": "Palo sinistro rosso",
  "block.minecraft.banner.stripe_right.white": "Palo sinistro bianco",
  "block.minecraft.banner.stripe_right.yellow": "Palo sinistro giallo",
  "block.minecraft.banner.stripe_top.black": "Fascia in capo nera",
  "block.minecraft.banner.stripe_top.blue": "Fascia in capo blu",
  "block.minecraft.banner.stripe_top.brown": "Fascia in capo marrone",
  "block.minecraft.banner.stripe_top.cyan": "Fascia in capo ciano",
  "block.minecraft.banner.stripe_top.gray": "Fascia in capo grigia",
  "block.minecraft.banner.stripe_top.green": "Fascia in capo verde",
  "block.minecraft.banner.stripe_top.light_blue": "Fascia in capo azzurra",
  "block.minecraft.banner.stripe_top.light_gray": "Fascia in capo grigio chiaro",
  "block.minecraft.banner.stripe_top.lime": "Fascia in capo lime",
  "block.minecraft.banner.stripe_top.magenta": "Fascia in capo magenta",
  "block.minecraft.banner.stripe_top.orange": "Fascia in capo arancione",
  "block.minecraft.banner.stripe_top.pink": "Fascia in capo rosa",
  "block.minecraft.banner.stripe_top.purple": "Fascia in capo viola",
  "block.minecraft.banner.stripe_top.red": "Fascia in capo rossa",
  "block.minecraft.banner.stripe_top.white": "Fascia in capo bianca",
  "block.minecraft.banner.stripe_top.yellow": "Fascia in capo gialla",
  "block.minecraft.banner.triangle_bottom.black": "Punta nera",
  "block.minecraft.banner.triangle_bottom.blue": "Punta blu",
  "block.minecraft.banner.triangle_bottom.brown": "Punta marrone",
  "block.minecraft.banner.triangle_bottom.cyan": "Punta ciano",
  "block.minecraft.banner.triangle_bottom.gray": "Punta grigia",
  "block.minecraft.banner.triangle_bottom.green": "Punta verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Punta azzurra",
  "block.minecraft.banner.triangle_bottom.light_gray": "Punta grigio chiaro",
  "block.minecraft.banner.triangle_bottom.lime": "Punta lime",
  "block.minecraft.banner.triangle_bottom.magenta": "Punta magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Punta arancione",
  "block.minecraft.banner.triangle_bottom.pink": "Punta rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Punta viola",
  "block.minecraft.banner.triangle_bottom.red": "Punta rossa",
  "block.minecraft.banner.triangle_bottom.white": "Punta bianca",
  "block.minecraft.banner.triangle_bottom.yellow": "Punta gialla",
  "block.minecraft.banner.triangle_top.black": "Punta rovesciata nera",
  "block.minecraft.banner.triangle_top.blue": "Punta rovesciata blu",
  "block.minecraft.banner.triangle_top.brown": "Punta rovesciata marrone",
  "block.minecraft.banner.triangle_top.cyan": "Punta rovesciata ciano",
  "block.minecraft.banner.triangle_top.gray": "Punta rovesciata grigia",
  "block.minecraft.banner.triangle_top.green": "Punta rovesciata verde",
  "block.minecraft.banner.triangle_top.light_blue": "Punta rovesciata azzurra",
  "block.minecraft.banner.triangle_top.light_gray": "Punta rovesciata grigio chiaro",
  "block.minecraft.banner.triangle_top.lime": "Punta rovesciata lime",
  "block.minecraft.banner.triangle_top.magenta": "Punta rovesciata magenta",
  "block.minecraft.banner.triangle_top.orange": "Punta rovesciata arancione",
  "block.minecraft.banner.triangle_top.pink": "Punta rovesciata rosa",
  "block.minecraft.banner.triangle_top.purple": "Punta rovesciata viola",
  "block.minecraft.banner.triangle_top.red": "Punta rovesciata rossa",
  "block.minecraft.banner.triangle_top.white": "Punta rovesciata bianca",
  "block.minecraft.banner.triangle_top.yellow": "Punta rovesciata gialla",
  "block.minecraft.banner.triangles_bottom.black": "Punta cuneata nera",
  "block.minecraft.banner.triangles_bottom.blue": "Punta cuneata blu",
  "block.minecraft.banner.triangles_bottom.brown": "Punta cuneata marrone",
  "block.minecraft.banner.triangles_bottom.cyan": "Punta cuneata ciano",
  "block.minecraft.banner.triangles_bottom.gray": "Punta cuneata grigia",
  "block.minecraft.banner.triangles_bottom.green": "Punta cuneata verde",
  "block.minecraft.banner.triangles_bottom.light_blue": "Punta cuneata azzurra",
  "block.minecraft.banner.triangles_bottom.light_gray": "Punta cuneata grigio chiaro",
  "block.minecraft.banner.triangles_bottom.lime": "Punta cuneata lime",
  "block.minecraft.banner.triangles_bottom.magenta": "Punta cuneata magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Punta cuneata arancione",
  "block.minecraft.banner.triangles_bottom.pink": "Punta cuneata rosa",
  "block.minecraft.banner.triangles_bottom.purple": "Punta cuneata viola",
  "block.minecraft.banner.triangles_bottom.red": "Punta cuneata rossa",
  "block.minecraft.banner.triangles_bottom.white": "Punta cuneata bianca",
  "block.minecraft.banner.triangles_bottom.yellow": "Punta cuneata gialla",
  "block.minecraft.banner.triangles_top.black": "Capo cuneato nero",
  "block.minecraft.banner.triangles_top.blue": "Capo cuneato blu",
  "block.minecraft.banner.triangles_top.brown": "Capo cuneato marrone",
  "block.minecraft.banner.triangles_top.cyan": "Capo cuneato ciano",
  "block.minecraft.banner.triangles_top.gray": "Capo cuneato grigio",
  "block.minecraft.banner.triangles_top.green": "Capo cuneato verde",
  "block.minecraft.banner.triangles_top.light_blue": "Capo cuneato azzurro",
  "block.minecraft.banner.triangles_top.light_gray": "Capo cuneato grigio chiaro",
  "block.minecraft.banner.triangles_top.lime": "Capo cuneato lime",
  "block.minecraft.banner.triangles_top.magenta": "Capo cuneato magenta",
  "block.minecraft.banner.triangles_top.orange": "Capo cuneato arancione",
  "block.minecraft.banner.triangles_top.pink": "Capo cuneato rosa",
  "block.minecraft.banner.triangles_top.purple": "Capo cuneato viola",
  "block.minecraft.banner.triangles_top.red": "Capo cuneato rosso",
  "block.minecraft.banner.triangles_top.white": "Capo cuneato bianco",
  "block.minecraft.banner.triangles_top.yellow": "Capo cuneato giallo",
  "block.minecraft.barrel": "Barile",
  "block.minecraft.barrier": "Barriera",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Potere primario",
  "block.minecraft.beacon.secondary": "Potere secondario",
  "block.minecraft.bed.no_sleep": "Puoi dormire solo di notte o durante un temporale",
  "block.minecraft.bed.not_safe": "Ora non puoi riposare: ci sono mostri nelle vicinanze",
  "block.minecraft.bed.obstructed": "Questo letto è ostruito",
  "block.minecraft.bed.occupied": "Questo letto è occupato",
  "block.minecraft.bed.too_far_away": "Ora non puoi riposare: il letto è troppo distante",
  "block.minecraft.bedrock": "Roccia di fondo",
  "block.minecraft.bee_nest": "Alveare",
  "block.minecraft.beehive": "Arnia",
  "block.minecraft.beetroots": "Barbabietole",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Piantaforma grande",
  "block.minecraft.big_dripleaf_stem": "Gambo di piantaforma grande",
  "block.minecraft.birch_button": "Pulsante di betulla",
  "block.minecraft.birch_door": "Porta di betulla",
  "block.minecraft.birch_fence": "Staccionata di betulla",
  "block.minecraft.birch_fence_gate": "Cancelletto di betulla",
  "block.minecraft.birch_hanging_sign": "Insegna di betulla",
  "block.minecraft.birch_leaves": "Foglie di betulla",
  "block.minecraft.birch_log": "Tronco di betulla",
  "block.minecraft.birch_planks": "Assi di betulla",
  "block.minecraft.birch_pressure_plate": "Pedana a pressione di betulla",
  "block.minecraft.birch_sapling": "Arboscello di betulla",
  "block.minecraft.birch_shelf": "Scaffale di betulla",
  "block.minecraft.birch_sign": "Cartello di betulla",
  "block.minecraft.birch_slab": "Lastra di betulla",
  "block.minecraft.birch_stairs": "Scalini di betulla",
  "block.minecraft.birch_trapdoor": "Botola di betulla",
  "block.minecraft.birch_wall_hanging_sign": "Insegna di betulla a parete",
  "block.minecraft.birch_wall_sign": "Cartello di betulla a parete",
  "block.minecraft.birch_wood": "Legno di betulla",
  "block.minecraft.black_banner": "Stendardo nero",
  "block.minecraft.black_bed": "Letto nero",
  "block.minecraft.black_candle": "Candela nera",
  "block.minecraft.black_candle_cake": "Torta con candela nera",
  "block.minecraft.black_carpet": "Tappeto nero",
  "block.minecraft.black_concrete": "Calcestruzzo nero",
  "block.minecraft.black_concrete_powder": "Polvere di calcestruzzo nera",
  "block.minecraft.black_glazed_terracotta": "Terracotta smaltata nera",
  "block.minecraft.black_shulker_box": "Scatola di shulker nera",
  "block.minecraft.black_stained_glass": "Vetro nero",
  "block.minecraft.black_stained_glass_pane": "Pannello di vetro nero",
  "block.minecraft.black_terracotta": "Terracotta nera",
  "block.minecraft.black_wool": "Lana nera",
  "block.minecraft.blackstone": "Pietranera",
  "block.minecraft.blackstone_slab": "Lastra di pietranera",
  "block.minecraft.blackstone_stairs": "Scalini di pietranera",
  "block.minecraft.blackstone_wall": "Muretto di pietranera",
  "block.minecraft.blast_furnace": "Forno fusorio",
  "block.minecraft.blue_banner": "Stendardo blu",
  "block.minecraft.blue_bed": "Letto blu",
  "block.minecraft.blue_candle": "Candela blu",
  "block.minecraft.blue_candle_cake": "Torta con candela blu",
  "block.minecraft.blue_carpet": "Tappeto blu",
  "block.minecraft.blue_concrete": "Calcestruzzo blu",
  "block.minecraft.blue_concrete_powder": "Polvere di calcestruzzo blu",
  "block.minecraft.blue_glazed_terracotta": "Terracotta smaltata blu",
  "block.minecraft.blue_ice": "Ghiaccio azzurro",
  "block.minecraft.blue_orchid": "Orchidea blu",
  "block.minecraft.blue_shulker_box": "Scatola di shulker blu",
  "block.minecraft.blue_stained_glass": "Vetro blu",
  "block.minecraft.blue_stained_glass_pane": "Pannello di vetro blu",
  "block.minecraft.blue_terracotta": "Terracotta blu",
  "block.minecraft.blue_wool": "Lana blu",
  "block.minecraft.bone_block": "Blocco di ossa",
  "block.minecraft.bookshelf": "Libreria",
  "block.minecraft.brain_coral": "Corallo a cervello",
  "block.minecraft.brain_coral_block": "Blocco di corallo a cervello",
  "block.minecraft.brain_coral_fan": "Gorgonia a cervello",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia a cervello a parete",
  "block.minecraft.brewing_stand": "Alambicco",
  "block.minecraft.brick_slab": "Lastra di mattoni",
  "block.minecraft.brick_stairs": "Scalini di mattoni",
  "block.minecraft.brick_wall": "Muretto di mattoni",
  "block.minecraft.bricks": "Mattoni",
  "block.minecraft.brown_banner": "Stendardo marrone",
  "block.minecraft.brown_bed": "Letto marrone",
  "block.minecraft.brown_candle": "Candela marrone",
  "block.minecraft.brown_candle_cake": "Torta con candela marrone",
  "block.minecraft.brown_carpet": "Tappeto marrone",
  "block.minecraft.brown_concrete": "Calcestruzzo marrone",
  "block.minecraft.brown_concrete_powder": "Polvere di calcestruzzo marrone",
  "block.minecraft.brown_glazed_terracotta": "Terracotta smaltata marrone",
  "block.minecraft.brown_mushroom": "Fungo marrone",
  "block.minecraft.brown_mushroom_block": "Blocco di fungo marrone",
  "block.minecraft.brown_shulker_box": "Scatola di shulker marrone",
  "block.minecraft.brown_stained_glass": "Vetro marrone",
  "block.minecraft.brown_stained_glass_pane": "Pannello di vetro marrone",
  "block.minecraft.brown_terracotta": "Terracotta marrone",
  "block.minecraft.brown_wool": "Lana marrone",
  "block.minecraft.bubble_column": "Colonna di bolle",
  "block.minecraft.bubble_coral": "Corallo a bolle",
  "block.minecraft.bubble_coral_block": "Blocco di corallo a bolle",
  "block.minecraft.bubble_coral_fan": "Gorgonia a bolle",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia a bolle a parete",
  "block.minecraft.budding_amethyst": "Ametista gemmante",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Fiore di cactus",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Sensore di sculk calibrato",
  "block.minecraft.campfire": "Fuoco da campo",
  "block.minecraft.candle": "Candela",
  "block.minecraft.candle_cake": "Torta con candela",
  "block.minecraft.carrots": "Carote",
  "block.minecraft.cartography_table": "Banco da cartografia",
  "block.minecraft.carved_pumpkin": "Zucca intagliata",
  "block.minecraft.cauldron": "Calderone",
  "block.minecraft.cave_air": "Aria delle caverne",
  "block.minecraft.cave_vines": "Rampicante delle caverne",
  "block.minecraft.cave_vines_plant": "Fusto di rampicante delle caverne",
  "block.minecraft.chain": "Catena",
  "block.minecraft.chain_command_block": "Blocco comandi a catena",
  "block.minecraft.cherry_button": "Pulsante di ciliegio",
  "block.minecraft.cherry_door": "Porta di ciliegio",
  "block.minecraft.cherry_fence": "Staccionata di ciliegio",
  "block.minecraft.cherry_fence_gate": "Cancelletto di ciliegio",
  "block.minecraft.cherry_hanging_sign": "Insegna di ciliegio",
  "block.minecraft.cherry_leaves": "Foglie di ciliegio",
  "block.minecraft.cherry_log": "Tronco di ciliegio",
  "block.minecraft.cherry_planks": "Assi di ciliegio",
  "block.minecraft.cherry_pressure_plate": "Pedana a pressione di ciliegio",
  "block.minecraft.cherry_sapling": "Arboscello di ciliegio",
  "block.minecraft.cherry_shelf": "Scaffale di ciliegio",
  "block.minecraft.cherry_sign": "Cartello di ciliegio",
  "block.minecraft.cherry_slab": "Lastra di ciliegio",
  "block.minecraft.cherry_stairs": "Scalini di ciliegio",
  "block.minecraft.cherry_trapdoor": "Botola di ciliegio",
  "block.minecraft.cherry_wall_hanging_sign": "Insegna di ciliegio a parete",
  "block.minecraft.cherry_wall_sign": "Cartello di ciliegio a parete",
  "block.minecraft.cherry_wood": "Legno di ciliegio",
  "block.minecraft.chest": "Baule",
  "block.minecraft.chipped_anvil": "Incudine scheggiata",
  "block.minecraft.chiseled_bookshelf": "Libreria cesellata",
  "block.minecraft.chiseled_copper": "Rame cesellato",
  "block.minecraft.chiseled_deepslate": "Ardesia profonda cesellata",
  "block.minecraft.chiseled_nether_bricks": "Mattoni del Nether cesellati",
  "block.minecraft.chiseled_polished_blackstone": "Pietranera levigata cesellata",
  "block.minecraft.chiseled_quartz_block": "Blocco di quarzo cesellato",
  "block.minecraft.chiseled_red_sandstone": "Arenaria rossa cesellata",
  "block.minecraft.chiseled_resin_bricks": "Mattoni di resina cesellati",
  "block.minecraft.chiseled_sandstone": "Arenaria cesellata",
  "block.minecraft.chiseled_stone_bricks": "Mattoni di pietra cesellati",
  "block.minecraft.chiseled_tuff": "Tufo cesellato",
  "block.minecraft.chiseled_tuff_bricks": "Mattoni di tufo cesellati",
  "block.minecraft.chorus_flower": "Fiore del coro",
  "block.minecraft.chorus_plant": "Pianta del coro",
  "block.minecraft.clay": "Argilla",
  "block.minecraft.closed_eyeblossom": "Occhidea chiusa",
  "block.minecraft.coal_block": "Blocco di carbone",
  "block.minecraft.coal_ore": "Minerale di carbone",
  "block.minecraft.coarse_dirt": "Terra brulla",
  "block.minecraft.cobbled_deepslate": "Pietrisco di ardesia profonda",
  "block.minecraft.cobbled_deepslate_slab": "Lastra di pietrisco di ardesia profonda",
  "block.minecraft.cobbled_deepslate_stairs": "Scalini di pietrisco di ardesia profonda",
  "block.minecraft.cobbled_deepslate_wall": "Muretto di pietrisco di ardesia profonda",
  "block.minecraft.cobblestone": "Pietrisco",
  "block.minecraft.cobblestone_slab": "Lastra di pietrisco",
  "block.minecraft.cobblestone_stairs": "Scalini di pietrisco",
  "block.minecraft.cobblestone_wall": "Muretto di pietrisco",
  "block.minecraft.cobweb": "Ragnatela",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Blocco comandi",
  "block.minecraft.comparator": "Comparatore di redstone",
  "block.minecraft.composter": "Compostiera",
  "block.minecraft.conduit": "Condotto",
  "block.minecraft.copper_bars": "Sbarre di rame",
  "block.minecraft.copper_block": "Blocco di rame",
  "block.minecraft.copper_bulb": "Lampada di rame",
  "block.minecraft.copper_chain": "Catena di rame",
  "block.minecraft.copper_chest": "Baule di rame",
  "block.minecraft.copper_door": "Porta di rame",
  "block.minecraft.copper_golem_statue": "Statua di golem di rame",
  "block.minecraft.copper_grate": "Grata di rame",
  "block.minecraft.copper_lantern": "Lanterna di rame",
  "block.minecraft.copper_ore": "Minerale di rame",
  "block.minecraft.copper_torch": "Torcia di rame",
  "block.minecraft.copper_trapdoor": "Botola di rame",
  "block.minecraft.copper_wall_torch": "Torcia di rame a parete",
  "block.minecraft.cornflower": "Fiordaliso",
  "block.minecraft.cracked_deepslate_bricks": "Mattoni di ardesia profonda crepati",
  "block.minecraft.cracked_deepslate_tiles": "Piastrelle di ardesia profonda crepate",
  "block.minecraft.cracked_nether_bricks": "Mattoni del Nether crepati",
  "block.minecraft.cracked_polished_blackstone_bricks": "Mattoni di pietranera levigata crepati",
  "block.minecraft.cracked_stone_bricks": "Mattoni di pietra crepati",
  "block.minecraft.crafter": "Fabbricatore",
  "block.minecraft.crafting_table": "Banco da lavoro",
  "block.minecraft.creaking_heart": "Cuore di scricchio",
  "block.minecraft.creeper_head": "Testa di creeper",
  "block.minecraft.creeper_wall_head": "Testa di creeper a parete",
  "block.minecraft.crimson_button": "Pulsante cremisi",
  "block.minecraft.crimson_door": "Porta cremisi",
  "block.minecraft.crimson_fence": "Staccionata cremisi",
  "block.minecraft.crimson_fence_gate": "Cancelletto cremisi",
  "block.minecraft.crimson_fungus": "Fungo cremisi",
  "block.minecraft.crimson_hanging_sign": "Insegna cremisi",
  "block.minecraft.crimson_hyphae": "Ife cremisi",
  "block.minecraft.crimson_nylium": "Necelio cremisi",
  "block.minecraft.crimson_planks": "Assi cremisi",
  "block.minecraft.crimson_pressure_plate": "Pedana a pressione cremisi",
  "block.minecraft.crimson_roots": "Radici cremisi",
  "block.minecraft.crimson_shelf": "Scaffale cremisi",
  "block.minecraft.crimson_sign": "Cartello cremisi",
  "block.minecraft.crimson_slab": "Lastra cremisi",
  "block.minecraft.crimson_stairs": "Scalini cremisi",
  "block.minecraft.crimson_stem": "Gambo cremisi",
  "block.minecraft.crimson_trapdoor": "Botola cremisi",
  "block.minecraft.crimson_wall_hanging_sign": "Insegna cremisi a parete",
  "block.minecraft.crimson_wall_sign": "Cartello cremisi a parete",
  "block.minecraft.crying_obsidian": "Ossidiana piangente",
  "block.minecraft.cut_copper": "Rame inciso",
  "block.minecraft.cut_copper_slab": "Lastra di rame inciso",
  "block.minecraft.cut_copper_stairs": "Scalini di rame inciso",
  "block.minecraft.cut_red_sandstone": "Arenaria rossa incisa",
  "block.minecraft.cut_red_sandstone_slab": "Lastra di arenaria rossa incisa",
  "block.minecraft.cut_sandstone": "Arenaria incisa",
  "block.minecraft.cut_sandstone_slab": "Lastra di arenaria incisa",
  "block.minecraft.cyan_banner": "Stendardo ciano",
  "block.minecraft.cyan_bed": "Letto ciano",
  "block.minecraft.cyan_candle": "Candela ciano",
  "block.minecraft.cyan_candle_cake": "Torta con candela ciano",
  "block.minecraft.cyan_carpet": "Tappeto ciano",
  "block.minecraft.cyan_concrete": "Calcestruzzo ciano",
  "block.minecraft.cyan_concrete_powder": "Polvere di calcestruzzo ciano",
  "block.minecraft.cyan_glazed_terracotta": "Terracotta smaltata ciano",
  "block.minecraft.cyan_shulker_box": "Scatola di shulker ciano",
  "block.minecraft.cyan_stained_glass": "Vetro ciano",
  "block.minecraft.cyan_stained_glass_pane": "Pannello di vetro ciano",
  "block.minecraft.cyan_terracotta": "Terracotta ciano",
  "block.minecraft.cyan_wool": "Lana ciano",
  "block.minecraft.damaged_anvil": "Incudine danneggiata",
  "block.minecraft.dandelion": "Dente di leone",
  "block.minecraft.dark_oak_button": "Pulsante di quercia scura",
  "block.minecraft.dark_oak_door": "Porta di quercia scura",
  "block.minecraft.dark_oak_fence": "Staccionata di quercia scura",
  "block.minecraft.dark_oak_fence_gate": "Cancelletto di quercia scura",
  "block.minecraft.dark_oak_hanging_sign": "Insegna di quercia scura",
  "block.minecraft.dark_oak_leaves": "Foglie di quercia scura",
  "block.minecraft.dark_oak_log": "Tronco di quercia scura",
  "block.minecraft.dark_oak_planks": "Assi di quercia scura",
  "block.minecraft.dark_oak_pressure_plate": "Pedana a pressione di quercia scura",
  "block.minecraft.dark_oak_sapling": "Arboscello di quercia scura",
  "block.minecraft.dark_oak_shelf": "Scaffale di quercia scura",
  "block.minecraft.dark_oak_sign": "Cartello di quercia scura",
  "block.minecraft.dark_oak_slab": "Lastra di quercia scura",
  "block.minecraft.dark_oak_stairs": "Scalini di quercia scura",
  "block.minecraft.dark_oak_trapdoor": "Botola di quercia scura",
  "block.minecraft.dark_oak_wall_hanging_sign": "Insegna di quercia scura a parete",
  "block.minecraft.dark_oak_wall_sign": "Cartello di quercia scura a parete",
  "block.minecraft.dark_oak_wood": "Legno di quercia scura",
  "block.minecraft.dark_prismarine": "Prismarino scuro",
  "block.minecraft.dark_prismarine_slab": "Lastra di prismarino scuro",
  "block.minecraft.dark_prismarine_stairs": "Scalini di prismarino scuro",
  "block.minecraft.daylight_detector": "Sensore di luce diurna",
  "block.minecraft.dead_brain_coral": "Corallo a cervello morto",
  "block.minecraft.dead_brain_coral_block": "Blocco di corallo a cervello morto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia a cervello morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia a cervello morta a parete",
  "block.minecraft.dead_bubble_coral": "Corallo a bolle morto",
  "block.minecraft.dead_bubble_coral_block": "Blocco di corallo a bolle morto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia a bolle morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia a bolle morta a parete",
  "block.minecraft.dead_bush": "Arbusto secco",
  "block.minecraft.dead_fire_coral": "Corallo di fuoco morto",
  "block.minecraft.dead_fire_coral_block": "Blocco di corallo di fuoco morto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia di fuoco morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia di fuoco morta a parete",
  "block.minecraft.dead_horn_coral": "Corallo a corna morto",
  "block.minecraft.dead_horn_coral_block": "Blocco di corallo a corna morto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia a corna morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia a corna morta a parete",
  "block.minecraft.dead_tube_coral": "Corallo a tubo morto",
  "block.minecraft.dead_tube_coral_block": "Blocco di corallo a tubo morto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia a tubo morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia a tubo morta a parete",
  "block.minecraft.decorated_pot": "Vaso decorato",
  "block.minecraft.deepslate": "Ardesia profonda",
  "block.minecraft.deepslate_brick_slab": "Lastra di mattoni di ardesia profonda",
  "block.minecraft.deepslate_brick_stairs": "Scalini di mattoni di ardesia profonda",
  "block.minecraft.deepslate_brick_wall": "Muretto di mattoni di ardesia profonda",
  "block.minecraft.deepslate_bricks": "Mattoni di ardesia profonda",
  "block.minecraft.deepslate_coal_ore": "Minerale di carbone in ardesia profonda",
  "block.minecraft.deepslate_copper_ore": "Minerale di rame in ardesia profonda",
  "block.minecraft.deepslate_diamond_ore": "Minerale di diamante in ardesia profonda",
  "block.minecraft.deepslate_emerald_ore": "Minerale di smeraldo in ardesia profonda",
  "block.minecraft.deepslate_gold_ore": "Minerale d'oro in ardesia profonda",
  "block.minecraft.deepslate_iron_ore": "Minerale di ferro in ardesia profonda",
  "block.minecraft.deepslate_lapis_ore": "Minerale di lapislazzuli in ardesia profonda",
  "block.minecraft.deepslate_redstone_ore": "Minerale di redstone in ardesia profonda",
  "block.minecraft.deepslate_tile_slab": "Lastra di piastrelle di ardesia profonda",
  "block.minecraft.deepslate_tile_stairs": "Scalini di piastrelle di ardesia profonda",
  "block.minecraft.deepslate_tile_wall": "Muretto di piastrelle di ardesia profonda",
  "block.minecraft.deepslate_tiles": "Piastrelle di ardesia profonda",
  "block.minecraft.detector_rail": "Binario rilevatore",
  "block.minecraft.diamond_block": "Blocco di diamante",
  "block.minecraft.diamond_ore": "Minerale di diamante",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Lastra di diorite",
  "block.minecraft.diorite_stairs": "Scalini di diorite",
  "block.minecraft.diorite_wall": "Muretto di diorite",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Sentiero sterrato",
  "block.minecraft.dispenser": "Distributore",
  "block.minecraft.dragon_egg": "Uovo di drago",
  "block.minecraft.dragon_head": "Testa di drago",
  "block.minecraft.dragon_wall_head": "Testa di drago a parete",
  "block.minecraft.dried_ghast": "Ghast essiccato",
  "block.minecraft.dried_kelp_block": "Blocco di alghe essiccate",
  "block.minecraft.dripstone_block": "Blocco di speleotema",
  "block.minecraft.dropper": "Gettatore",
  "block.minecraft.emerald_block": "Blocco di smeraldo",
  "block.minecraft.emerald_ore": "Minerale di smeraldo",
  "block.minecraft.enchanting_table": "Tavolo per incantesimi",
  "block.minecraft.end_gateway": "Varco dell'End",
  "block.minecraft.end_portal": "Portale dell'End",
  "block.minecraft.end_portal_frame": "Telaio del portale dell'End",
  "block.minecraft.end_rod": "Barra dell'End",
  "block.minecraft.end_stone": "Pietra dell'End",
  "block.minecraft.end_stone_brick_slab": "Lastra di mattoni di pietra dell'End",
  "block.minecraft.end_stone_brick_stairs": "Scalini di mattoni di pietra dell'End",
  "block.minecraft.end_stone_brick_wall": "Muretto di mattoni di pietra dell'End",
  "block.minecraft.end_stone_bricks": "Mattoni di pietra dell'End",
  "block.minecraft.ender_chest": "Baule di ender",
  "block.minecraft.exposed_chiseled_copper": "Rame cesellato esposto",
  "block.minecraft.exposed_copper": "Rame esposto",
  "block.minecraft.exposed_copper_bars": "Sbarre di rame esposto",
  "block.minecraft.exposed_copper_bulb": "Lampada di rame esposto",
  "block.minecraft.exposed_copper_chain": "Catena di rame esposto",
  "block.minecraft.exposed_copper_chest": "Baule di rame esposto",
  "block.minecraft.exposed_copper_door": "Porta di rame esposto",
  "block.minecraft.exposed_copper_golem_statue": "Statua di golem di rame esposto",
  "block.minecraft.exposed_copper_grate": "Grata di rame esposto",
  "block.minecraft.exposed_copper_lantern": "Lanterna di rame esposto",
  "block.minecraft.exposed_copper_trapdoor": "Botola di rame esposto",
  "block.minecraft.exposed_cut_copper": "Rame inciso esposto",
  "block.minecraft.exposed_cut_copper_slab": "Lastra di rame inciso esposto",
  "block.minecraft.exposed_cut_copper_stairs": "Scalini di rame inciso esposto",
  "block.minecraft.exposed_lightning_rod": "Parafulmine esposto",
  "block.minecraft.farmland": "Terra zappata",
  "block.minecraft.fern": "Felce",
  "block.minecraft.fire": "Fuoco",
  "block.minecraft.fire_coral": "Corallo di fuoco",
  "block.minecraft.fire_coral_block": "Blocco di corallo di fuoco",
  "block.minecraft.fire_coral_fan": "Gorgonia di fuoco",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia di fuoco a parete",
  "block.minecraft.firefly_bush": "Cespuglio di lucciole",
  "block.minecraft.fletching_table": "Banco da impennatura",
  "block.minecraft.flower_pot": "Vaso da fiori",
  "block.minecraft.flowering_azalea": "Azalea fiorita",
  "block.minecraft.flowering_azalea_leaves": "Foglie di azalea fiorite",
  "block.minecraft.frogspawn": "Uova di rana",
  "block.minecraft.frosted_ice": "Gelo",
  "block.minecraft.furnace": "Fornace",
  "block.minecraft.gilded_blackstone": "Pietranera dorata",
  "block.minecraft.glass": "Vetro",
  "block.minecraft.glass_pane": "Pannello di vetro",
  "block.minecraft.glow_lichen": "Lichene luminescente",
  "block.minecraft.glowstone": "Luminite",
  "block.minecraft.gold_block": "Blocco d'oro",
  "block.minecraft.gold_ore": "Minerale d'oro",
  "block.minecraft.golden_dandelion": "Dente di leone d'oro",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Lastra di granito",
  "block.minecraft.granite_stairs": "Scalini di granito",
  "block.minecraft.granite_wall": "Muretto di granito",
  "block.minecraft.grass": "Erba",
  "block.minecraft.grass_block": "Blocco d'erba",
  "block.minecraft.gravel": "Ghiaia",
  "block.minecraft.gray_banner": "Stendardo grigio",
  "block.minecraft.gray_bed": "Letto grigio",
  "block.minecraft.gray_candle": "Candela grigia",
  "block.minecraft.gray_candle_cake": "Torta con candela grigia",
  "block.minecraft.gray_carpet": "Tappeto grigio",
  "block.minecraft.gray_concrete": "Calcestruzzo grigio",
  "block.minecraft.gray_concrete_powder": "Polvere di calcestruzzo grigia",
  "block.minecraft.gray_glazed_terracotta": "Terracotta smaltata grigia",
  "block.minecraft.gray_shulker_box": "Scatola di shulker grigia",
  "block.minecraft.gray_stained_glass": "Vetro grigio",
  "block.minecraft.gray_stained_glass_pane": "Pannello di vetro grigio",
  "block.minecraft.gray_terracotta": "Terracotta grigia",
  "block.minecraft.gray_wool": "Lana grigia",
  "block.minecraft.green_banner": "Stendardo verde",
  "block.minecraft.green_bed": "Letto verde",
  "block.minecraft.green_candle": "Candela verde",
  "block.minecraft.green_candle_cake": "Torta con candela verde",
  "block.minecraft.green_carpet": "Tappeto verde",
  "block.minecraft.green_concrete": "Calcestruzzo verde",
  "block.minecraft.green_concrete_powder": "Polvere di calcestruzzo verde",
  "block.minecraft.green_glazed_terracotta": "Terracotta smaltata verde",
  "block.minecraft.green_shulker_box": "Scatola di shulker verde",
  "block.minecraft.green_stained_glass": "Vetro verde",
  "block.minecraft.green_stained_glass_pane": "Pannello di vetro verde",
  "block.minecraft.green_terracotta": "Terracotta verde",
  "block.minecraft.green_wool": "Lana verde",
  "block.minecraft.grindstone": "Mola",
  "block.minecraft.hanging_roots": "Radici pendenti",
  "block.minecraft.hay_block": "Balla di fieno",
  "block.minecraft.heavy_core": "Nucleo pesante",
  "block.minecraft.heavy_weighted_pressure_plate": "Pedana a pressione per pesi elevati",
  "block.minecraft.honey_block": "Blocco di miele",
  "block.minecraft.honeycomb_block": "Blocco di favi",
  "block.minecraft.hopper": "Tramoggia",
  "block.minecraft.horn_coral": "Corallo a corna",
  "block.minecraft.horn_coral_block": "Blocco di corallo a corna",
  "block.minecraft.horn_coral_fan": "Gorgonia a corna",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia a corna a parete",
  "block.minecraft.ice": "Ghiaccio",
  "block.minecraft.infested_chiseled_stone_bricks": "Mattoni di pietra cesellati infestati",
  "block.minecraft.infested_cobblestone": "Pietrisco infestato",
  "block.minecraft.infested_cracked_stone_bricks": "Mattoni di pietra crepati infestati",
  "block.minecraft.infested_deepslate": "Ardesia profonda infestata",
  "block.minecraft.infested_mossy_stone_bricks": "Mattoni di pietra muschiosi infestati",
  "block.minecraft.infested_stone": "Pietra infestata",
  "block.minecraft.infested_stone_bricks": "Mattoni di pietra infestati",
  "block.minecraft.iron_bars": "Sbarre di ferro",
  "block.minecraft.iron_block": "Blocco di ferro",
  "block.minecraft.iron_chain": "Catena di ferro",
  "block.minecraft.iron_door": "Porta di ferro",
  "block.minecraft.iron_ore": "Minerale di ferro",
  "block.minecraft.iron_trapdoor": "Botola di ferro",
  "block.minecraft.jack_o_lantern": "Lanterna di zucca",
  "block.minecraft.jigsaw": "Blocco puzzle",
  "block.minecraft.jukebox": "Giradischi",
  "block.minecraft.jungle_button": "Pulsante della giungla",
  "block.minecraft.jungle_door": "Porta della giungla",
  "block.minecraft.jungle_fence": "Staccionata della giungla",
  "block.minecraft.jungle_fence_gate": "Cancelletto della giungla",
  "block.minecraft.jungle_hanging_sign": "Insegna della giungla",
  "block.minecraft.jungle_leaves": "Foglie della giungla",
  "block.minecraft.jungle_log": "Tronco della giungla",
  "block.minecraft.jungle_planks": "Assi della giungla",
  "block.minecraft.jungle_pressure_plate": "Pedana a pressione della giungla",
  "block.minecraft.jungle_sapling": "Arboscello della giungla",
  "block.minecraft.jungle_shelf": "Scaffale della giungla",
  "block.minecraft.jungle_sign": "Cartello della giungla",
  "block.minecraft.jungle_slab": "Lastra della giungla",
  "block.minecraft.jungle_stairs": "Scalini della giungla",
  "block.minecraft.jungle_trapdoor": "Botola della giungla",
  "block.minecraft.jungle_wall_hanging_sign": "Insegna della giungla a parete",
  "block.minecraft.jungle_wall_sign": "Cartello della giungla a parete",
  "block.minecraft.jungle_wood": "Legno della giungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Gambo di alga",
  "block.minecraft.ladder": "Scala a pioli",
  "block.minecraft.lantern": "Lanterna",
  "block.minecraft.lapis_block": "Blocco di lapislazzuli",
  "block.minecraft.lapis_ore": "Minerale di lapislazzuli",
  "block.minecraft.large_amethyst_bud": "Gemma di ametista grande",
  "block.minecraft.large_fern": "Felce grande",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Calderone di lava",
  "block.minecraft.leaf_litter": "Fogliame",
  "block.minecraft.lectern": "Leggio",
  "block.minecraft.lever": "Leva",
  "block.minecraft.light": "Luce",
  "block.minecraft.light_blue_banner": "Stendardo azzurro",
  "block.minecraft.light_blue_bed": "Letto azzurro",
  "block.minecraft.light_blue_candle": "Candela azzurra",
  "block.minecraft.light_blue_candle_cake": "Torta con candela azzurra",
  "block.minecraft.light_blue_carpet": "Tappeto azzurro",
  "block.minecraft.light_blue_concrete": "Calcestruzzo azzurro",
  "block.minecraft.light_blue_concrete_powder": "Polvere di calcestruzzo azzurra",
  "block.minecraft.light_blue_glazed_terracotta": "Terracotta smaltata azzurra",
  "block.minecraft.light_blue_shulker_box": "Scatola di shulker azzurra",
  "block.minecraft.light_blue_stained_glass": "Vetro azzurro",
  "block.minecraft.light_blue_stained_glass_pane": "Pannello di vetro azzurro",
  "block.minecraft.light_blue_terracotta": "Terracotta azzurra",
  "block.minecraft.light_blue_wool": "Lana azzurra",
  "block.minecraft.light_gray_banner": "Stendardo grigio chiaro",
  "block.minecraft.light_gray_bed": "Letto grigio chiaro",
  "block.minecraft.light_gray_candle": "Candela grigio chiaro",
  "block.minecraft.light_gray_candle_cake": "Torta con candela grigio chiaro",
  "block.minecraft.light_gray_carpet": "Tappeto grigio chiaro",
  "block.minecraft.light_gray_concrete": "Calcestruzzo grigio chiaro",
  "block.minecraft.light_gray_concrete_powder": "Polvere di calcestruzzo grigio chiaro",
  "block.minecraft.light_gray_glazed_terracotta": "Terracotta smaltata grigio chiaro",
  "block.minecraft.light_gray_shulker_box": "Scatola di shulker grigio chiaro",
  "block.minecraft.light_gray_stained_glass": "Vetro grigio chiaro",
  "block.minecraft.light_gray_stained_glass_pane": "Pannello di vetro grigio chiaro",
  "block.minecraft.light_gray_terracotta": "Terracotta grigio chiaro",
  "block.minecraft.light_gray_wool": "Lana grigio chiaro",
  "block.minecraft.light_weighted_pressure_plate": "Pedana a pressione per piccoli pesi",
  "block.minecraft.lightning_rod": "Parafulmine",
  "block.minecraft.lilac": "Lillà",
  "block.minecraft.lily_of_the_valley": "Mughetto",
  "block.minecraft.lily_pad": "Ninfea",
  "block.minecraft.lime_banner": "Stendardo lime",
  "block.minecraft.lime_bed": "Letto lime",
  "block.minecraft.lime_candle": "Candela lime",
  "block.minecraft.lime_candle_cake": "Torta con candela lime",
  "block.minecraft.lime_carpet": "Tappeto lime",
  "block.minecraft.lime_concrete": "Calcestruzzo lime",
  "block.minecraft.lime_concrete_powder": "Polvere di calcestruzzo lime",
  "block.minecraft.lime_glazed_terracotta": "Terracotta smaltata lime",
  "block.minecraft.lime_shulker_box": "Scatola di shulker lime",
  "block.minecraft.lime_stained_glass": "Vetro lime",
  "block.minecraft.lime_stained_glass_pane": "Pannello di vetro lime",
  "block.minecraft.lime_terracotta": "Terracotta lime",
  "block.minecraft.lime_wool": "Lana lime",
  "block.minecraft.lodestone": "Magnetite",
  "block.minecraft.loom": "Telaio",
  "block.minecraft.magenta_banner": "Stendardo magenta",
  "block.minecraft.magenta_bed": "Letto magenta",
  "block.minecraft.magenta_candle": "Candela magenta",
  "block.minecraft.magenta_candle_cake": "Torta con candela magenta",
  "block.minecraft.magenta_carpet": "Tappeto magenta",
  "block.minecraft.magenta_concrete": "Calcestruzzo magenta",
  "block.minecraft.magenta_concrete_powder": "Polvere di calcestruzzo magenta",
  "block.minecraft.magenta_glazed_terracotta": "Terracotta smaltata magenta",
  "block.minecraft.magenta_shulker_box": "Scatola di shulker magenta",
  "block.minecraft.magenta_stained_glass": "Vetro magenta",
  "block.minecraft.magenta_stained_glass_pane": "Pannello di vetro magenta",
  "block.minecraft.magenta_terracotta": "Terracotta magenta",
  "block.minecraft.magenta_wool": "Lana magenta",
  "block.minecraft.magma_block": "Blocco di magma",
  "block.minecraft.mangrove_button": "Pulsante di mangrovia",
  "block.minecraft.mangrove_door": "Porta di mangrovia",
  "block.minecraft.mangrove_fence": "Staccionata di mangrovia",
  "block.minecraft.mangrove_fence_gate": "Cancelletto di mangrovia",
  "block.minecraft.mangrove_hanging_sign": "Insegna di mangrovia",
  "block.minecraft.mangrove_leaves": "Foglie di mangrovia",
  "block.minecraft.mangrove_log": "Tronco di mangrovia",
  "block.minecraft.mangrove_planks": "Assi di mangrovia",
  "block.minecraft.mangrove_pressure_plate": "Pedana a pressione di mangrovia",
  "block.minecraft.mangrove_propagule": "Propagulo di mangrovia",
  "block.minecraft.mangrove_roots": "Radici di mangrovia",
  "block.minecraft.mangrove_shelf": "Scaffale di mangrovia",
  "block.minecraft.mangrove_sign": "Cartello di mangrovia",
  "block.minecraft.mangrove_slab": "Lastra di mangrovia",
  "block.minecraft.mangrove_stairs": "Scalini di mangrovia",
  "block.minecraft.mangrove_trapdoor": "Botola di mangrovia",
  "block.minecraft.mangrove_wall_hanging_sign": "Insegna di mangrovia a parete",
  "block.minecraft.mangrove_wall_sign": "Cartello di mangrovia a parete",
  "block.minecraft.mangrove_wood": "Legno di mangrovia",
  "block.minecraft.medium_amethyst_bud": "Gemma di ametista media",
  "block.minecraft.melon": "Anguria",
  "block.minecraft.melon_stem": "Pianta di anguria",
  "block.minecraft.moss_block": "Blocco di muschio",
  "block.minecraft.moss_carpet": "Tappeto di muschio",
  "block.minecraft.mossy_cobblestone": "Pietrisco muschioso",
  "block.minecraft.mossy_cobblestone_slab": "Lastra di pietrisco muschioso",
  "block.minecraft.mossy_cobblestone_stairs": "Scalini di pietrisco muschioso",
  "block.minecraft.mossy_cobblestone_wall": "Muretto di pietrisco muschioso",
  "block.minecraft.mossy_stone_brick_slab": "Lastra di mattoni di pietra muschiosi",
  "block.minecraft.mossy_stone_brick_stairs": "Scalini di mattoni di pietra muschiosi",
  "block.minecraft.mossy_stone_brick_wall": "Muretto di mattoni di pietra muschiosi",
  "block.minecraft.mossy_stone_bricks": "Mattoni di pietra muschiosi",
  "block.minecraft.moving_piston": "Blocco in movimento",
  "block.minecraft.mud": "Fango",
  "block.minecraft.mud_brick_slab": "Lastra di mattoni di fango",
  "block.minecraft.mud_brick_stairs": "Scalini di mattoni di fango",
  "block.minecraft.mud_brick_wall": "Muretto di mattoni di fango",
  "block.minecraft.mud_bricks": "Mattoni di fango",
  "block.minecraft.muddy_mangrove_roots": "Radici di mangrovia fangose",
  "block.minecraft.mushroom_stem": "Gambo di fungo",
  "block.minecraft.mycelium": "Micelio",
  "block.minecraft.nether_brick_fence": "Staccionata di mattoni del Nether",
  "block.minecraft.nether_brick_slab": "Lastra di mattoni del Nether",
  "block.minecraft.nether_brick_stairs": "Scalini di mattoni del Nether",
  "block.minecraft.nether_brick_wall": "Muretto di mattoni del Nether",
  "block.minecraft.nether_bricks": "Mattoni del Nether",
  "block.minecraft.nether_gold_ore": "Minerale d'oro del Nether",
  "block.minecraft.nether_portal": "Portale del Nether",
  "block.minecraft.nether_quartz_ore": "Minerale di quarzo del Nether",
  "block.minecraft.nether_sprouts": "Germogli del Nether",
  "block.minecraft.nether_wart": "Verruca del Nether",
  "block.minecraft.nether_wart_block": "Blocco di verruche del Nether",
  "block.minecraft.netherite_block": "Blocco di netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Blocco sonoro",
  "block.minecraft.oak_button": "Pulsante di quercia",
  "block.minecraft.oak_door": "Porta di quercia",
  "block.minecraft.oak_fence": "Staccionata di quercia",
  "block.minecraft.oak_fence_gate": "Cancelletto di quercia",
  "block.minecraft.oak_hanging_sign": "Insegna di quercia",
  "block.minecraft.oak_leaves": "Foglie di quercia",
  "block.minecraft.oak_log": "Tronco di quercia",
  "block.minecraft.oak_planks": "Assi di quercia",
  "block.minecraft.oak_pressure_plate": "Pedana a pressione di quercia",
  "block.minecraft.oak_sapling": "Arboscello di quercia",
  "block.minecraft.oak_shelf": "Scaffale di quercia",
  "block.minecraft.oak_sign": "Cartello di quercia",
  "block.minecraft.oak_slab": "Lastra di quercia",
  "block.minecraft.oak_stairs": "Scalini di quercia",
  "block.minecraft.oak_trapdoor": "Botola di quercia",
  "block.minecraft.oak_wall_hanging_sign": "Insegna a parete di quercia",
  "block.minecraft.oak_wall_sign": "Cartello di quercia a parete",
  "block.minecraft.oak_wood": "Legno di quercia",
  "block.minecraft.observer": "Osservatore",
  "block.minecraft.obsidian": "Ossidiana",
  "block.minecraft.ochre_froglight": "Lanterana ocra",
  "block.minecraft.ominous_banner": "Stendardo infausto",
  "block.minecraft.open_eyeblossom": "Occhidea aperta",
  "block.minecraft.orange_banner": "Stendardo arancione",
  "block.minecraft.orange_bed": "Letto arancione",
  "block.minecraft.orange_candle": "Candela arancione",
  "block.minecraft.orange_candle_cake": "Torta con candela arancione",
  "block.minecraft.orange_carpet": "Tappeto arancione",
  "block.minecraft.orange_concrete": "Calcestruzzo arancione",
  "block.minecraft.orange_concrete_powder": "Polvere di calcestruzzo arancione",
  "block.minecraft.orange_glazed_terracotta": "Terracotta smaltata arancione",
  "block.minecraft.orange_shulker_box": "Scatola di shulker arancione",
  "block.minecraft.orange_stained_glass": "Vetro arancione",
  "block.minecraft.orange_stained_glass_pane": "Pannello di vetro arancione",
  "block.minecraft.orange_terracotta": "Terracotta arancione",
  "block.minecraft.orange_tulip": "Tulipano arancione",
  "block.minecraft.orange_wool": "Lana arancione",
  "block.minecraft.oxeye_daisy": "Margherita",
  "block.minecraft.oxidized_chiseled_copper": "Rame cesellato ossidato",
  "block.minecraft.oxidized_copper": "Rame ossidato",
  "block.minecraft.oxidized_copper_bars": "Sbarre di rame ossidato",
  "block.minecraft.oxidized_copper_bulb": "Lampada di rame ossidato",
  "block.minecraft.oxidized_copper_chain": "Catena di rame ossidato",
  "block.minecraft.oxidized_copper_chest": "Baule di rame ossidato",
  "block.minecraft.oxidized_copper_door": "Porta di rame ossidato",
  "block.minecraft.oxidized_copper_golem_statue": "Statua di golem di rame ossidato",
  "block.minecraft.oxidized_copper_grate": "Grata di rame ossidato",
  "block.minecraft.oxidized_copper_lantern": "Lanterna di rame ossidato",
  "block.minecraft.oxidized_copper_trapdoor": "Botola di rame ossidato",
  "block.minecraft.oxidized_cut_copper": "Rame inciso ossidato",
  "block.minecraft.oxidized_cut_copper_slab": "Lastra di rame inciso ossidato",
  "block.minecraft.oxidized_cut_copper_stairs": "Scalini di rame inciso ossidato",
  "block.minecraft.oxidized_lightning_rod": "Parafulmine ossidato",
  "block.minecraft.packed_ice": "Ghiaccio compatto",
  "block.minecraft.packed_mud": "Fango compatto",
  "block.minecraft.pale_hanging_moss": "Muschio pendente pallido",
  "block.minecraft.pale_moss_block": "Blocco di muschio pallido",
  "block.minecraft.pale_moss_carpet": "Tappeto di muschio pallido",
  "block.minecraft.pale_oak_button": "Pulsante di quercia pallida",
  "block.minecraft.pale_oak_door": "Porta di quercia pallida",
  "block.minecraft.pale_oak_fence": "Staccionata di quercia pallida",
  "block.minecraft.pale_oak_fence_gate": "Cancelletto di quercia pallida",
  "block.minecraft.pale_oak_hanging_sign": "Insegna di quercia pallida",
  "block.minecraft.pale_oak_leaves": "Foglie di quercia pallida",
  "block.minecraft.pale_oak_log": "Tronco di quercia pallida",
  "block.minecraft.pale_oak_planks": "Assi di quercia pallida",
  "block.minecraft.pale_oak_pressure_plate": "Pedana a pressione di quercia pallida",
  "block.minecraft.pale_oak_sapling": "Arboscello di quercia pallida",
  "block.minecraft.pale_oak_shelf": "Scaffale di quercia pallida",
  "block.minecraft.pale_oak_sign": "Cartello di quercia pallida",
  "block.minecraft.pale_oak_slab": "Lastra di quercia pallida",
  "block.minecraft.pale_oak_stairs": "Scalini di quercia pallida",
  "block.minecraft.pale_oak_trapdoor": "Botola di quercia pallida",
  "block.minecraft.pale_oak_wall_hanging_sign": "Insegna di quercia pallida a parete",
  "block.minecraft.pale_oak_wall_sign": "Cartello di quercia pallida a parete",
  "block.minecraft.pale_oak_wood": "Legno di quercia pallida",
  "block.minecraft.pearlescent_froglight": "Lanterana perlacea",
  "block.minecraft.peony": "Peonia",
  "block.minecraft.petrified_oak_slab": "Lastra di quercia pietrificata",
  "block.minecraft.piglin_head": "Testa di piglin",
  "block.minecraft.piglin_wall_head": "Testa di piglin a parete",
  "block.minecraft.pink_banner": "Stendardo rosa",
  "block.minecraft.pink_bed": "Letto rosa",
  "block.minecraft.pink_candle": "Candela rosa",
  "block.minecraft.pink_candle_cake": "Torta con candela rosa",
  "block.minecraft.pink_carpet": "Tappeto rosa",
  "block.minecraft.pink_concrete": "Calcestruzzo rosa",
  "block.minecraft.pink_concrete_powder": "Polvere di calcestruzzo rosa",
  "block.minecraft.pink_glazed_terracotta": "Terracotta smaltata rosa",
  "block.minecraft.pink_petals": "Petali rosa",
  "block.minecraft.pink_shulker_box": "Scatola di shulker rosa",
  "block.minecraft.pink_stained_glass": "Vetro rosa",
  "block.minecraft.pink_stained_glass_pane": "Pannello di vetro rosa",
  "block.minecraft.pink_terracotta": "Terracotta rosa",
  "block.minecraft.pink_tulip": "Tulipano rosa",
  "block.minecraft.pink_wool": "Lana rosa",
  "block.minecraft.piston": "Pistone",
  "block.minecraft.piston_head": "Testa di pistone",
  "block.minecraft.pitcher_crop": "Coltura di pianta carnivora",
  "block.minecraft.pitcher_plant": "Pianta carnivora",
  "block.minecraft.player_head": "Testa di giocatore",
  "block.minecraft.player_head.named": "Testa di %s",
  "block.minecraft.player_wall_head": "Testa di giocatore a parete",
  "block.minecraft.podzol": "Terra grigia",
  "block.minecraft.pointed_dripstone": "Speleotema appuntito",
  "block.minecraft.polished_andesite": "Andesite levigata",
  "block.minecraft.polished_andesite_slab": "Lastra di andesite levigata",
  "block.minecraft.polished_andesite_stairs": "Scalini di andesite levigata",
  "block.minecraft.polished_basalt": "Basalto levigato",
  "block.minecraft.polished_blackstone": "Pietranera levigata",
  "block.minecraft.polished_blackstone_brick_slab": "Lastra di mattoni di pietranera levigata",
  "block.minecraft.polished_blackstone_brick_stairs": "Scalini di mattoni di pietranera levigata",
  "block.minecraft.polished_blackstone_brick_wall": "Muretto di mattoni di pietranera levigata",
  "block.minecraft.polished_blackstone_bricks": "Mattoni di pietranera levigata",
  "block.minecraft.polished_blackstone_button": "Pulsante di pietranera levigata",
  "block.minecraft.polished_blackstone_pressure_plate": "Pedana a pressione di pietranera levigata",
  "block.minecraft.polished_blackstone_slab": "Lastra di pietranera levigata",
  "block.minecraft.polished_blackstone_stairs": "Scalini di pietranera levigata",
  "block.minecraft.polished_blackstone_wall": "Muretto di pietranera levigata",
  "block.minecraft.polished_deepslate": "Ardesia profonda levigata",
  "block.minecraft.polished_deepslate_slab": "Lastra di ardesia profonda levigata",
  "block.minecraft.polished_deepslate_stairs": "Scalini di ardesia profonda levigata",
  "block.minecraft.polished_deepslate_wall": "Muretto di ardesia profonda levigata",
  "block.minecraft.polished_diorite": "Diorite levigata",
  "block.minecraft.polished_diorite_slab": "Lastra di diorite levigata",
  "block.minecraft.polished_diorite_stairs": "Scalini di diorite levigata",
  "block.minecraft.polished_granite": "Granito levigato",
  "block.minecraft.polished_granite_slab": "Lastra di granito levigato",
  "block.minecraft.polished_granite_stairs": "Scalini di granito levigato",
  "block.minecraft.polished_tuff": "Tufo levigato",
  "block.minecraft.polished_tuff_slab": "Lastra di tufo levigato",
  "block.minecraft.polished_tuff_stairs": "Scalini di tufo levigato",
  "block.minecraft.polished_tuff_wall": "Muretto di tufo levigato",
  "block.minecraft.poppy": "Papavero",
  "block.minecraft.potatoes": "Patate",
  "block.minecraft.potted_acacia_sapling": "Vaso con arboscello di acacia",
  "block.minecraft.potted_allium": "Vaso con fiore d'aglio",
  "block.minecraft.potted_azalea_bush": "Vaso con azalea",
  "block.minecraft.potted_azure_bluet": "Vaso con houstonia",
  "block.minecraft.potted_bamboo": "Vaso con bambù",
  "block.minecraft.potted_birch_sapling": "Vaso con arboscello di betulla",
  "block.minecraft.potted_blue_orchid": "Vaso con orchidea blu",
  "block.minecraft.potted_brown_mushroom": "Vaso con fungo marrone",
  "block.minecraft.potted_cactus": "Vaso con cactus",
  "block.minecraft.potted_cherry_sapling": "Vaso con arboscello di ciliegio",
  "block.minecraft.potted_closed_eyeblossom": "Vaso con occhidea chiusa",
  "block.minecraft.potted_cornflower": "Vaso con fiordaliso",
  "block.minecraft.potted_crimson_fungus": "Vaso con fungo cremisi",
  "block.minecraft.potted_crimson_roots": "Vaso con radici cremisi",
  "block.minecraft.potted_dandelion": "Vaso con dente di leone",
  "block.minecraft.potted_dark_oak_sapling": "Vaso con arboscello di quercia scura",
  "block.minecraft.potted_dead_bush": "Vaso con arbusto secco",
  "block.minecraft.potted_fern": "Vaso con felce",
  "block.minecraft.potted_flowering_azalea_bush": "Vaso con azalea fiorita",
  "block.minecraft.potted_golden_dandelion": "Vaso con dente di leone d'oro",
  "block.minecraft.potted_jungle_sapling": "Vaso con arboscello della giungla",
  "block.minecraft.potted_lily_of_the_valley": "Vaso con mughetto",
  "block.minecraft.potted_mangrove_propagule": "Vaso con propagulo di mangrovia",
  "block.minecraft.potted_oak_sapling": "Vaso con arboscello di quercia",
  "block.minecraft.potted_open_eyeblossom": "Vaso con occhidea aperta",
  "block.minecraft.potted_orange_tulip": "Vaso con tulipano arancione",
  "block.minecraft.potted_oxeye_daisy": "Vaso con margherita",
  "block.minecraft.potted_pale_oak_sapling": "Vaso con arboscello di quercia pallida",
  "block.minecraft.potted_pink_tulip": "Vaso con tulipano rosa",
  "block.minecraft.potted_poppy": "Vaso con papavero",
  "block.minecraft.potted_red_mushroom": "Vaso con fungo rosso",
  "block.minecraft.potted_red_tulip": "Vaso con tulipano rosso",
  "block.minecraft.potted_spruce_sapling": "Vaso con arboscello di abete",
  "block.minecraft.potted_torchflower": "Vaso con fiortorcia",
  "block.minecraft.potted_warped_fungus": "Vaso con fungo distorto",
  "block.minecraft.potted_warped_roots": "Vaso con radici distorte",
  "block.minecraft.potted_white_tulip": "Vaso con tulipano bianco",
  "block.minecraft.potted_wither_rose": "Vaso con rosa di Wither",
  "block.minecraft.powder_snow": "Neve polverosa",
  "block.minecraft.powder_snow_cauldron": "Calderone di neve polverosa",
  "block.minecraft.powered_rail": "Binario alimentato",
  "block.minecraft.prismarine": "Prismarino",
  "block.minecraft.prismarine_brick_slab": "Lastra di mattoni di prismarino",
  "block.minecraft.prismarine_brick_stairs": "Scalini di mattoni di prismarino",
  "block.minecraft.prismarine_bricks": "Mattoni di prismarino",
  "block.minecraft.prismarine_slab": "Lastra di prismarino",
  "block.minecraft.prismarine_stairs": "Scalini di prismarino",
  "block.minecraft.prismarine_wall": "Muretto di prismarino",
  "block.minecraft.pumpkin": "Zucca",
  "block.minecraft.pumpkin_stem": "Pianta di zucca",
  "block.minecraft.purple_banner": "Stendardo viola",
  "block.minecraft.purple_bed": "Letto viola",
  "block.minecraft.purple_candle": "Candela viola",
  "block.minecraft.purple_candle_cake": "Torta con candela viola",
  "block.minecraft.purple_carpet": "Tappeto viola",
  "block.minecraft.purple_concrete": "Calcestruzzo viola",
  "block.minecraft.purple_concrete_powder": "Polvere di calcestruzzo viola",
  "block.minecraft.purple_glazed_terracotta": "Terracotta smaltata viola",
  "block.minecraft.purple_shulker_box": "Scatola di shulker viola",
  "block.minecraft.purple_stained_glass": "Vetro viola",
  "block.minecraft.purple_stained_glass_pane": "Pannello di vetro viola",
  "block.minecraft.purple_terracotta": "Terracotta viola",
  "block.minecraft.purple_wool": "Lana viola",
  "block.minecraft.purpur_block": "Blocco di purpur",
  "block.minecraft.purpur_pillar": "Pilastro di purpur",
  "block.minecraft.purpur_slab": "Lastra di purpur",
  "block.minecraft.purpur_stairs": "Scalini di purpur",
  "block.minecraft.quartz_block": "Blocco di quarzo",
  "block.minecraft.quartz_bricks": "Mattoni di quarzo",
  "block.minecraft.quartz_pillar": "Pilastro di quarzo",
  "block.minecraft.quartz_slab": "Lastra di quarzo",
  "block.minecraft.quartz_stairs": "Scalini di quarzo",
  "block.minecraft.rail": "Binario",
  "block.minecraft.raw_copper_block": "Blocco di rame grezzo",
  "block.minecraft.raw_gold_block": "Blocco d'oro grezzo",
  "block.minecraft.raw_iron_block": "Blocco di ferro grezzo",
  "block.minecraft.red_banner": "Stendardo rosso",
  "block.minecraft.red_bed": "Letto rosso",
  "block.minecraft.red_candle": "Candela rossa",
  "block.minecraft.red_candle_cake": "Torta con candela rossa",
  "block.minecraft.red_carpet": "Tappeto rosso",
  "block.minecraft.red_concrete": "Calcestruzzo rosso",
  "block.minecraft.red_concrete_powder": "Polvere di calcestruzzo rossa",
  "block.minecraft.red_glazed_terracotta": "Terracotta smaltata rossa",
  "block.minecraft.red_mushroom": "Fungo rosso",
  "block.minecraft.red_mushroom_block": "Blocco di fungo rosso",
  "block.minecraft.red_nether_brick_slab": "Lastra di mattoni del Nether rossi",
  "block.minecraft.red_nether_brick_stairs": "Scalini di mattoni del Nether rossi",
  "block.minecraft.red_nether_brick_wall": "Muretto di mattoni del Nether rossi",
  "block.minecraft.red_nether_bricks": "Mattoni del Nether rossi",
  "block.minecraft.red_sand": "Sabbia rossa",
  "block.minecraft.red_sandstone": "Arenaria rossa",
  "block.minecraft.red_sandstone_slab": "Lastra di arenaria rossa",
  "block.minecraft.red_sandstone_stairs": "Scalini di arenaria rossa",
  "block.minecraft.red_sandstone_wall": "Muretto di arenaria rossa",
  "block.minecraft.red_shulker_box": "Scatola di shulker rossa",
  "block.minecraft.red_stained_glass": "Vetro rosso",
  "block.minecraft.red_stained_glass_pane": "Pannello di vetro rosso",
  "block.minecraft.red_terracotta": "Terracotta rossa",
  "block.minecraft.red_tulip": "Tulipano rosso",
  "block.minecraft.red_wool": "Lana rossa",
  "block.minecraft.redstone_block": "Blocco di redstone",
  "block.minecraft.redstone_lamp": "Lampada a redstone",
  "block.minecraft.redstone_ore": "Minerale di redstone",
  "block.minecraft.redstone_torch": "Torcia di redstone",
  "block.minecraft.redstone_wall_torch": "Torcia di redstone a parete",
  "block.minecraft.redstone_wire": "Cavo di redstone",
  "block.minecraft.reinforced_deepslate": "Ardesia profonda armata",
  "block.minecraft.repeater": "Ripetitore di redstone",
  "block.minecraft.repeating_command_block": "Blocco comandi a ripetizione",
  "block.minecraft.resin_block": "Blocco di resina",
  "block.minecraft.resin_brick_slab": "Lastra di mattoni di resina",
  "block.minecraft.resin_brick_stairs": "Scalini di mattoni di resina",
  "block.minecraft.resin_brick_wall": "Muretto di mattoni di resina",
  "block.minecraft.resin_bricks": "Mattoni di resina",
  "block.minecraft.resin_clump": "Grumo di resina",
  "block.minecraft.respawn_anchor": "Ancora della rinascita",
  "block.minecraft.rooted_dirt": "Terra con radici",
  "block.minecraft.rose_bush": "Rosaio",
  "block.minecraft.sand": "Sabbia",
  "block.minecraft.sandstone": "Arenaria",
  "block.minecraft.sandstone_slab": "Lastra di arenaria",
  "block.minecraft.sandstone_stairs": "Scalini di arenaria",
  "block.minecraft.sandstone_wall": "Muretto di arenaria",
  "block.minecraft.scaffolding": "Impalcatura",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizzatore di sculk",
  "block.minecraft.sculk_sensor": "Sensore di sculk",
  "block.minecraft.sculk_shrieker": "Sculk urlatore",
  "block.minecraft.sculk_vein": "Vena di sculk",
  "block.minecraft.sea_lantern": "Lanterna marina",
  "block.minecraft.sea_pickle": "Cetriolo di mare",
  "block.minecraft.seagrass": "Erba acquatica",
  "block.minecraft.set_spawn": "Il punto di rinascita è stato impostato",
  "block.minecraft.short_dry_grass": "Erba secca bassa",
  "block.minecraft.short_grass": "Erba bassa",
  "block.minecraft.shroomlight": "Fungilume",
  "block.minecraft.shulker_box": "Scatola di shulker",
  "block.minecraft.skeleton_skull": "Teschio di scheletro",
  "block.minecraft.skeleton_wall_skull": "Teschio di scheletro a parete",
  "block.minecraft.slime_block": "Blocco di gelatina",
  "block.minecraft.small_amethyst_bud": "Gemma di ametista piccola",
  "block.minecraft.small_dripleaf": "Piantaforma piccola",
  "block.minecraft.smithing_table": "Banco da forgiatura",
  "block.minecraft.smoker": "Affumicatore",
  "block.minecraft.smooth_basalt": "Basalto liscio",
  "block.minecraft.smooth_quartz": "Blocco di quarzo liscio",
  "block.minecraft.smooth_quartz_slab": "Lastra di quarzo liscio",
  "block.minecraft.smooth_quartz_stairs": "Scalini di quarzo liscio",
  "block.minecraft.smooth_red_sandstone": "Arenaria rossa liscia",
  "block.minecraft.smooth_red_sandstone_slab": "Lastra di arenaria rossa liscia",
  "block.minecraft.smooth_red_sandstone_stairs": "Scalini di arenaria rossa liscia",
  "block.minecraft.smooth_sandstone": "Arenaria liscia",
  "block.minecraft.smooth_sandstone_slab": "Lastra di arenaria liscia",
  "block.minecraft.smooth_sandstone_stairs": "Scalini di arenaria liscia",
  "block.minecraft.smooth_stone": "Pietra liscia",
  "block.minecraft.smooth_stone_slab": "Lastra di pietra liscia",
  "block.minecraft.sniffer_egg": "Uovo di fiutatore",
  "block.minecraft.snow": "Neve",
  "block.minecraft.snow_block": "Blocco di neve",
  "block.minecraft.soul_campfire": "Fuoco da campo delle anime",
  "block.minecraft.soul_fire": "Fuoco delle anime",
  "block.minecraft.soul_lantern": "Lanterna delle anime",
  "block.minecraft.soul_sand": "Sabbia delle anime",
  "block.minecraft.soul_soil": "Terra delle anime",
  "block.minecraft.soul_torch": "Torcia delle anime",
  "block.minecraft.soul_wall_torch": "Torcia delle anime a parete",
  "block.minecraft.spawn.not_valid": "Non hai alcun letto o ancora della rinascita alimentata, o sono ostruiti",
  "block.minecraft.spawner": "Generatore di mostri",
  "block.minecraft.spawner.desc1": "Interazione con uovo generatore:",
  "block.minecraft.spawner.desc2": "Imposta il tipo di creatura",
  "block.minecraft.sponge": "Spugna",
  "block.minecraft.spore_blossom": "Fiore sporifero",
  "block.minecraft.spruce_button": "Pulsante di abete",
  "block.minecraft.spruce_door": "Porta di abete",
  "block.minecraft.spruce_fence": "Staccionata di abete",
  "block.minecraft.spruce_fence_gate": "Cancelletto di abete",
  "block.minecraft.spruce_hanging_sign": "Insegna di abete",
  "block.minecraft.spruce_leaves": "Foglie di abete",
  "block.minecraft.spruce_log": "Tronco di abete",
  "block.minecraft.spruce_planks": "Assi di abete",
  "block.minecraft.spruce_pressure_plate": "Pedana a pressione di abete",
  "block.minecraft.spruce_sapling": "Arboscello di abete",
  "block.minecraft.spruce_shelf": "Scaffale di abete",
  "block.minecraft.spruce_sign": "Cartello di abete",
  "block.minecraft.spruce_slab": "Lastra di abete",
  "block.minecraft.spruce_stairs": "Scalini di abete",
  "block.minecraft.spruce_trapdoor": "Botola di abete",
  "block.minecraft.spruce_wall_hanging_sign": "Insegna di abete a parete",
  "block.minecraft.spruce_wall_sign": "Cartello di abete a parete",
  "block.minecraft.spruce_wood": "Legno di abete",
  "block.minecraft.sticky_piston": "Pistone appiccicoso",
  "block.minecraft.stone": "Pietra",
  "block.minecraft.stone_brick_slab": "Lastra di mattoni di pietra",
  "block.minecraft.stone_brick_stairs": "Scalini di mattoni di pietra",
  "block.minecraft.stone_brick_wall": "Muretto di mattoni di pietra",
  "block.minecraft.stone_bricks": "Mattoni di pietra",
  "block.minecraft.stone_button": "Pulsante di pietra",
  "block.minecraft.stone_pressure_plate": "Pedana a pressione di pietra",
  "block.minecraft.stone_slab": "Lastra di pietra",
  "block.minecraft.stone_stairs": "Scalini di pietra",
  "block.minecraft.stonecutter": "Tagliapietre",
  "block.minecraft.stripped_acacia_log": "Tronco di acacia scortecciato",
  "block.minecraft.stripped_acacia_wood": "Legno di acacia scortecciato",
  "block.minecraft.stripped_bamboo_block": "Blocco di bambù scortecciato",
  "block.minecraft.stripped_birch_log": "Tronco di betulla scortecciato",
  "block.minecraft.stripped_birch_wood": "Legno di betulla scortecciato",
  "block.minecraft.stripped_cherry_log": "Tronco di ciliegio scortecciato",
  "block.minecraft.stripped_cherry_wood": "Legno di ciliegio scortecciato",
  "block.minecraft.stripped_crimson_hyphae": "Ife cremisi scortecciate",
  "block.minecraft.stripped_crimson_stem": "Gambo cremisi scortecciato",
  "block.minecraft.stripped_dark_oak_log": "Tronco di quercia scura scortecciato",
  "block.minecraft.stripped_dark_oak_wood": "Legno di quercia scura scortecciato",
  "block.minecraft.stripped_jungle_log": "Tronco della giungla scortecciato",
  "block.minecraft.stripped_jungle_wood": "Legno della giungla scortecciato",
  "block.minecraft.stripped_mangrove_log": "Tronco di mangrovia scortecciato",
  "block.minecraft.stripped_mangrove_wood": "Legno di mangrovia scortecciato",
  "block.minecraft.stripped_oak_log": "Tronco di quercia scortecciato",
  "block.minecraft.stripped_oak_wood": "Legno di quercia scortecciato",
  "block.minecraft.stripped_pale_oak_log": "Tronco di quercia pallida scortecciato",
  "block.minecraft.stripped_pale_oak_wood": "Legno di quercia pallida scortecciato",
  "block.minecraft.stripped_spruce_log": "Tronco di abete scortecciato",
  "block.minecraft.stripped_spruce_wood": "Legno di abete scortecciato",
  "block.minecraft.stripped_warped_hyphae": "Ife distorte scortecciate",
  "block.minecraft.stripped_warped_stem": "Gambo distorto scortecciato",
  "block.minecraft.structure_block": "Blocco strutture",
  "block.minecraft.structure_void": "Vuoto della struttura",
  "block.minecraft.sugar_cane": "Canna da zucchero",
  "block.minecraft.sunflower": "Girasole",
  "block.minecraft.suspicious_gravel": "Ghiaia sospetta",
  "block.minecraft.suspicious_sand": "Sabbia sospetta",
  "block.minecraft.sweet_berry_bush": "Cespuglio di bacche dolci",
  "block.minecraft.tall_dry_grass": "Erba secca alta",
  "block.minecraft.tall_grass": "Erba alta",
  "block.minecraft.tall_seagrass": "Erba acquatica alta",
  "block.minecraft.target": "Bersaglio",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Blocco di test",
  "block.minecraft.test_instance_block": "Blocco di collaudo",
  "block.minecraft.tinted_glass": "Vetro oscurato",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Le esplosioni di TNT sono disattivate",
  "block.minecraft.torch": "Torcia",
  "block.minecraft.torchflower": "Fiortorcia",
  "block.minecraft.torchflower_crop": "Pianta di fiortorcia",
  "block.minecraft.trapped_chest": "Baule trappola",
  "block.minecraft.trial_spawner": "Generatore della sfida",
  "block.minecraft.tripwire": "Filo d'inciampo",
  "block.minecraft.tripwire_hook": "Gancio per filo d'inciampo",
  "block.minecraft.tube_coral": "Corallo a tubo",
  "block.minecraft.tube_coral_block": "Blocco di corallo a tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia a tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia a tubo a parete",
  "block.minecraft.tuff": "Tufo",
  "block.minecraft.tuff_brick_slab": "Lastra di mattoni di tufo",
  "block.minecraft.tuff_brick_stairs": "Scalini di mattoni di tufo",
  "block.minecraft.tuff_brick_wall": "Muretto di mattoni di tufo",
  "block.minecraft.tuff_bricks": "Mattoni di tufo",
  "block.minecraft.tuff_slab": "Lastra di tufo",
  "block.minecraft.tuff_stairs": "Scalini di tufo",
  "block.minecraft.tuff_wall": "Muretto di tufo",
  "block.minecraft.turtle_egg": "Uovo di tartaruga",
  "block.minecraft.twisting_vines": "Rampicante attorcigliato",
  "block.minecraft.twisting_vines_plant": "Fusto di rampicante attorcigliato",
  "block.minecraft.vault": "Cassaforte",
  "block.minecraft.verdant_froglight": "Lanterana verdeggiante",
  "block.minecraft.vine": "Rampicante",
  "block.minecraft.void_air": "Aria del vuoto",
  "block.minecraft.wall_torch": "Torcia a parete",
  "block.minecraft.warped_button": "Pulsante distorto",
  "block.minecraft.warped_door": "Porta distorta",
  "block.minecraft.warped_fence": "Staccionata distorta",
  "block.minecraft.warped_fence_gate": "Cancelletto distorto",
  "block.minecraft.warped_fungus": "Fungo distorto",
  "block.minecraft.warped_hanging_sign": "Insegna distorta",
  "block.minecraft.warped_hyphae": "Ife distorte",
  "block.minecraft.warped_nylium": "Necelio distorto",
  "block.minecraft.warped_planks": "Assi distorte",
  "block.minecraft.warped_pressure_plate": "Pedana a pressione distorta",
  "block.minecraft.warped_roots": "Radici distorte",
  "block.minecraft.warped_shelf": "Scaffale distorto",
  "block.minecraft.warped_sign": "Cartello distorto",
  "block.minecraft.warped_slab": "Lastra distorta",
  "block.minecraft.warped_stairs": "Scalini distorti",
  "block.minecraft.warped_stem": "Gambo distorto",
  "block.minecraft.warped_trapdoor": "Botola distorta",
  "block.minecraft.warped_wall_hanging_sign": "Insegna distorta a parete",
  "block.minecraft.warped_wall_sign": "Cartello distorto a parete",
  "block.minecraft.warped_wart_block": "Blocco di verruche distorte",
  "block.minecraft.water": "Acqua",
  "block.minecraft.water_cauldron": "Calderone d'acqua",
  "block.minecraft.waxed_chiseled_copper": "Rame cesellato cerato",
  "block.minecraft.waxed_copper_bars": "Sbarre di rame cerato",
  "block.minecraft.waxed_copper_block": "Blocco di rame cerato",
  "block.minecraft.waxed_copper_bulb": "Lampada di rame cerato",
  "block.minecraft.waxed_copper_chain": "Catena di rame cerato",
  "block.minecraft.waxed_copper_chest": "Baule di rame cerato",
  "block.minecraft.waxed_copper_door": "Porta di rame cerato",
  "block.minecraft.waxed_copper_golem_statue": "Statua di golem di rame cerato",
  "block.minecraft.waxed_copper_grate": "Grata di rame cerato",
  "block.minecraft.waxed_copper_lantern": "Lanterna di rame cerato",
  "block.minecraft.waxed_copper_trapdoor": "Botola di rame cerato",
  "block.minecraft.waxed_cut_copper": "Rame inciso cerato",
  "block.minecraft.waxed_cut_copper_slab": "Lastra di rame inciso cerato",
  "block.minecraft.waxed_cut_copper_stairs": "Scalini di rame inciso cerato",
  "block.minecraft.waxed_exposed_chiseled_copper": "Rame cesellato esposto cerato",
  "block.minecraft.waxed_exposed_copper": "Rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_bars": "Sbarre di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_bulb": "Lampada di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_chain": "Catena di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_chest": "Baule di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_door": "Porta di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statua di golem di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_grate": "Grata di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterna di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Botola di rame esposto cerato",
  "block.minecraft.waxed_exposed_cut_copper": "Rame inciso esposto cerato",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Lastra di rame inciso esposto cerato",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Scalini di rame inciso esposto cerato",
  "block.minecraft.waxed_exposed_lightning_rod": "Parafulmine esposto cerato",
  "block.minecraft.waxed_lightning_rod": "Parafulmine cerato",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Rame cesellato ossidato cerato",
  "block.minecraft.waxed_oxidized_copper": "Rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_bars": "Sbarre di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lampada di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_chain": "Catena di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_chest": "Baule di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_door": "Porta di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statua di golem di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_grate": "Grata di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterna di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Botola di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_cut_copper": "Rame inciso ossidato cerato",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Lastra di rame inciso ossidato cerato",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Scalini di rame inciso ossidato cerato",
  "block.minecraft.waxed_oxidized_lightning_rod": "Parafulmine ossidato cerato",
  "block.minecraft.waxed_weathered_chiseled_copper": "Rame cesellato corroso cerato",
  "block.minecraft.waxed_weathered_copper": "Rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_bars": "Sbarre di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_bulb": "Lampada di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_chain": "Catena di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_chest": "Baule di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_door": "Porta di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statua di golem di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_grate": "Grata di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterna di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Botola di rame corroso cerato",
  "block.minecraft.waxed_weathered_cut_copper": "Rame inciso corroso cerato",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Lastra di rame inciso corroso cerato",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Scalini di rame inciso corroso cerato",
  "block.minecraft.waxed_weathered_lightning_rod": "Parafulmine corroso cerato",
  "block.minecraft.weathered_chiseled_copper": "Rame cesellato corroso",
  "block.minecraft.weathered_copper": "Rame corroso",
  "block.minecraft.weathered_copper_bars": "Sbarre di rame corroso",
  "block.minecraft.weathered_copper_bulb": "Lampada di rame corroso",
  "block.minecraft.weathered_copper_chain": "Catena di rame corroso",
  "block.minecraft.weathered_copper_chest": "Baule di rame corroso",
  "block.minecraft.weathered_copper_door": "Porta di rame corroso",
  "block.minecraft.weathered_copper_golem_statue": "Statua di golem di rame corroso",
  "block.minecraft.weathered_copper_grate": "Grata di rame corroso",
  "block.minecraft.weathered_copper_lantern": "Lanterna di rame corroso",
  "block.minecraft.weathered_copper_trapdoor": "Botola di rame corroso",
  "block.minecraft.weathered_cut_copper": "Rame inciso corroso",
  "block.minecraft.weathered_cut_copper_slab": "Lastra di rame inciso corroso",
  "block.minecraft.weathered_cut_copper_stairs": "Scalini di rame inciso corroso",
  "block.minecraft.weathered_lightning_rod": "Parafulmine corroso",
  "block.minecraft.weeping_vines": "Rampicante piangente",
  "block.minecraft.weeping_vines_plant": "Fusto di rampicante piangente",
  "block.minecraft.wet_sponge": "Spugna bagnata",
  "block.minecraft.wheat": "Grano",
  "block.minecraft.white_banner": "Stendardo bianco",
  "block.minecraft.white_bed": "Letto bianco",
  "block.minecraft.white_candle": "Candela bianca",
  "block.minecraft.white_candle_cake": "Torta con candela bianca",
  "block.minecraft.white_carpet": "Tappeto bianco",
  "block.minecraft.white_concrete": "Calcestruzzo bianco",
  "block.minecraft.white_concrete_powder": "Polvere di calcestruzzo bianca",
  "block.minecraft.white_glazed_terracotta": "Terracotta smaltata bianca",
  "block.minecraft.white_shulker_box": "Scatola di shulker bianca",
  "block.minecraft.white_stained_glass": "Vetro bianco",
  "block.minecraft.white_stained_glass_pane": "Pannello di vetro bianco",
  "block.minecraft.white_terracotta": "Terracotta bianca",
  "block.minecraft.white_tulip": "Tulipano bianco",
  "block.minecraft.white_wool": "Lana bianca",
  "block.minecraft.wildflowers": "Fiori di campo",
  "block.minecraft.wither_rose": "Rosa di Wither",
  "block.minecraft.wither_skeleton_skull": "Teschio di scheletro di Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Teschio di scheletro di Wither a parete",
  "block.minecraft.yellow_banner": "Stendardo giallo",
  "block.minecraft.yellow_bed": "Letto giallo",
  "block.minecraft.yellow_candle": "Candela gialla",
  "block.minecraft.yellow_candle_cake": "Torta con candela gialla",
  "block.minecraft.yellow_carpet": "Tappeto giallo",
  "block.minecraft.yellow_concrete": "Calcestruzzo giallo",
  "block.minecraft.yellow_concrete_powder": "Polvere di calcestruzzo gialla",
  "block.minecraft.yellow_glazed_terracotta": "Terracotta smaltata gialla",
  "block.minecraft.yellow_shulker_box": "Scatola di shulker gialla",
  "block.minecraft.yellow_stained_glass": "Vetro giallo",
  "block.minecraft.yellow_stained_glass_pane": "Pannello di vetro giallo",
  "block.minecraft.yellow_terracotta": "Terracotta gialla",
  "block.minecraft.yellow_wool": "Lana gialla",
  "block.minecraft.zombie_head": "Testa di zombi",
  "block.minecraft.zombie_wall_head": "Testa di zombi a parete",
  "item.minecraft.acacia_boat": "Barca di acacia",
  "item.minecraft.acacia_chest_boat": "Barca di acacia con baule",
  "item.minecraft.allay_spawn_egg": "Uovo generatore di alleviante",
  "item.minecraft.amethyst_shard": "Scheggia di ametista",
  "item.minecraft.angler_pottery_shard": "Coccio con canna da pesca",
  "item.minecraft.angler_pottery_sherd": "Coccio con canna da pesca",
  "item.minecraft.apple": "Mela",
  "item.minecraft.archer_pottery_shard": "Frammento con arco e freccia",
  "item.minecraft.archer_pottery_sherd": "Coccio con arco e freccia",
  "item.minecraft.armadillo_scute": "Squama di armadillo",
  "item.minecraft.armadillo_spawn_egg": "Uovo generatore di armadillo",
  "item.minecraft.armor_stand": "Supporto per armature",
  "item.minecraft.arms_up_pottery_shard": "Coccio con alzata di braccia",
  "item.minecraft.arms_up_pottery_sherd": "Coccio con alzata di braccia",
  "item.minecraft.arrow": "Freccia",
  "item.minecraft.axolotl_bucket": "Secchio con assolotto",
  "item.minecraft.axolotl_spawn_egg": "Uovo generatore di assolotto",
  "item.minecraft.baked_potato": "Patata al forno",
  "item.minecraft.bamboo_chest_raft": "Zattera di bambù con baule",
  "item.minecraft.bamboo_raft": "Zattera di bambù",
  "item.minecraft.bat_spawn_egg": "Uovo generatore di pipistrello",
  "item.minecraft.bee_spawn_egg": "Uovo generatore di ape",
  "item.minecraft.beef": "Manzo crudo",
  "item.minecraft.beetroot": "Barbabietola",
  "item.minecraft.beetroot_seeds": "Semi di barbabietola",
  "item.minecraft.beetroot_soup": "Zuppa di barbabietole",
  "item.minecraft.birch_boat": "Barca di betulla",
  "item.minecraft.birch_chest_boat": "Barca di betulla con baule",
  "item.minecraft.black_bundle": "Sacchetto nero",
  "item.minecraft.black_dye": "Colorante nero",
  "item.minecraft.black_harness": "Imbracatura nera",
  "item.minecraft.blade_pottery_shard": "Coccio con lama",
  "item.minecraft.blade_pottery_sherd": "Coccio con lama",
  "item.minecraft.blaze_powder": "Polvere di blaze",
  "item.minecraft.blaze_rod": "Verga di blaze",
  "item.minecraft.blaze_spawn_egg": "Uovo generatore di blaze",
  "item.minecraft.blue_bundle": "Sacchetto blu",
  "item.minecraft.blue_dye": "Colorante blu",
  "item.minecraft.blue_egg": "Uovo blu",
  "item.minecraft.blue_harness": "Imbracatura blu",
  "item.minecraft.bogged_spawn_egg": "Uovo generatore di paludoso",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornamento stile bullone",
  "item.minecraft.bone": "Osso",
  "item.minecraft.bone_meal": "Farina di ossa",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Motivo con bordatura dentata",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Ciotola",
  "item.minecraft.bread": "Pane",
  "item.minecraft.breeze_rod": "Verga di brezza",
  "item.minecraft.breeze_spawn_egg": "Uovo generatore di brezza",
  "item.minecraft.brewer_pottery_shard": "Coccio con ampolla",
  "item.minecraft.brewer_pottery_sherd": "Coccio con ampolla",
  "item.minecraft.brewing_stand": "Alambicco",
  "item.minecraft.brick": "Mattone",
  "item.minecraft.brown_bundle": "Sacchetto marrone",
  "item.minecraft.brown_dye": "Colorante marrone",
  "item.minecraft.brown_egg": "Uovo marrone",
  "item.minecraft.brown_harness": "Imbracatura marrone",
  "item.minecraft.brush": "Spazzola",
  "item.minecraft.bucket": "Secchio",
  "item.minecraft.bundle": "Sacchetto",
  "item.minecraft.bundle.empty": "Vuoto",
  "item.minecraft.bundle.empty.description": "Può contenere una pila mista di oggetti",
  "item.minecraft.bundle.full": "Pieno",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Coccio con fiamma",
  "item.minecraft.burn_pottery_sherd": "Coccio con fiamma",
  "item.minecraft.camel_husk_spawn_egg": "Uovo generatore di mummifario",
  "item.minecraft.camel_spawn_egg": "Uovo generatore di dromedario",
  "item.minecraft.carrot": "Carota",
  "item.minecraft.carrot_on_a_stick": "Bastone e carota",
  "item.minecraft.cat_spawn_egg": "Uovo generatore di gatto",
  "item.minecraft.cauldron": "Calderone",
  "item.minecraft.cave_spider_spawn_egg": "Uovo generatore di ragno delle caverne",
  "item.minecraft.chainmail_boots": "Scarpe di maglia",
  "item.minecraft.chainmail_chestplate": "Cotta di maglia",
  "item.minecraft.chainmail_helmet": "Cuffia di maglia",
  "item.minecraft.chainmail_leggings": "Brache di maglia",
  "item.minecraft.charcoal": "Carbonella",
  "item.minecraft.cherry_boat": "Barca di ciliegio",
  "item.minecraft.cherry_chest_boat": "Barca di ciliegio con baule",
  "item.minecraft.chest_minecart": "Vagonetto con baule",
  "item.minecraft.chicken": "Pollo crudo",
  "item.minecraft.chicken_spawn_egg": "Uovo generatore di gallina",
  "item.minecraft.chorus_fruit": "Frutto del coro",
  "item.minecraft.clay_ball": "Zolla di argilla",
  "item.minecraft.clock": "Orologio",
  "item.minecraft.coal": "Carbone",
  "item.minecraft.coast_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornamento stile costiero",
  "item.minecraft.cocoa_beans": "Fave di cacao",
  "item.minecraft.cod": "Merluzzo crudo",
  "item.minecraft.cod_bucket": "Secchio con merluzzo",
  "item.minecraft.cod_spawn_egg": "Uovo generatore di merluzzo",
  "item.minecraft.command_block_minecart": "Vagonetto con blocco comandi",
  "item.minecraft.compass": "Bussola",
  "item.minecraft.cooked_beef": "Bistecca",
  "item.minecraft.cooked_chicken": "Pollo cotto",
  "item.minecraft.cooked_cod": "Merluzzo cotto",
  "item.minecraft.cooked_mutton": "Carne ovina cotta",
  "item.minecraft.cooked_porkchop": "Costoletta di maiale cotta",
  "item.minecraft.cooked_rabbit": "Coniglio cotto",
  "item.minecraft.cooked_salmon": "Salmone cotto",
  "item.minecraft.cookie": "Biscotto",
  "item.minecraft.copper_axe": "Ascia di rame",
  "item.minecraft.copper_boots": "Stivali di rame",
  "item.minecraft.copper_chestplate": "Corazza di rame",
  "item.minecraft.copper_golem_spawn_egg": "Uovo generatore di golem di rame",
  "item.minecraft.copper_helmet": "Elmo di rame",
  "item.minecraft.copper_hoe": "Zappa di rame",
  "item.minecraft.copper_horse_armor": "Bardatura di rame",
  "item.minecraft.copper_ingot": "Lingotto di rame",
  "item.minecraft.copper_leggings": "Gambiere di rame",
  "item.minecraft.copper_nautilus_armor": "Armatura di rame per nautili",
  "item.minecraft.copper_nugget": "Pepita di rame",
  "item.minecraft.copper_pickaxe": "Piccone di rame",
  "item.minecraft.copper_shovel": "Pala di rame",
  "item.minecraft.copper_spear": "Lancia di rame",
  "item.minecraft.copper_sword": "Spada di rame",
  "item.minecraft.cow_spawn_egg": "Uovo generatore di mucca",
  "item.minecraft.creaking_spawn_egg": "Uovo generatore di scricchio",
  "item.minecraft.creeper_banner_pattern": "Motivo per stendardo",
  "item.minecraft.creeper_banner_pattern.desc": "Volto di creeper",
  "item.minecraft.creeper_banner_pattern.new": "Motivo con volto di creeper",
  "item.minecraft.creeper_spawn_egg": "Uovo generatore di creeper",
  "item.minecraft.crossbow": "Balestra",
  "item.minecraft.crossbow.projectile": "Proiettile:",
  "item.minecraft.crossbow.projectile.multiple": "Proiettile: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Proiettile: %s",
  "item.minecraft.cyan_bundle": "Sacchetto ciano",
  "item.minecraft.cyan_dye": "Colorante ciano",
  "item.minecraft.cyan_harness": "Imbracatura ciano",
  "item.minecraft.danger_pottery_shard": "Coccio con avvertimento",
  "item.minecraft.danger_pottery_sherd": "Coccio con avvertimento",
  "item.minecraft.dark_oak_boat": "Barca di quercia scura",
  "item.minecraft.dark_oak_chest_boat": "Barca di quercia scura con baule",
  "item.minecraft.debug_stick": "Bastone di debug",
  "item.minecraft.debug_stick.empty": "%s non ha proprietà",
  "item.minecraft.debug_stick.select": "selezionato «%s» («%s»)",
  "item.minecraft.debug_stick.update": "%s → %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Ascia di diamante",
  "item.minecraft.diamond_boots": "Stivali di diamante",
  "item.minecraft.diamond_chestplate": "Corazza di diamante",
  "item.minecraft.diamond_helmet": "Elmo di diamante",
  "item.minecraft.diamond_hoe": "Zappa di diamante",
  "item.minecraft.diamond_horse_armor": "Bardatura di diamante",
  "item.minecraft.diamond_leggings": "Gambiere di diamante",
  "item.minecraft.diamond_nautilus_armor": "Armatura di diamante per nautili",
  "item.minecraft.diamond_pickaxe": "Piccone di diamante",
  "item.minecraft.diamond_shovel": "Pala di diamante",
  "item.minecraft.diamond_spear": "Lancia di diamante",
  "item.minecraft.diamond_sword": "Spada di diamante",
  "item.minecraft.disc_fragment_5": "Frammento di disco",
  "item.minecraft.disc_fragment_5.desc": "Disco musicale — 5",
  "item.minecraft.dolphin_spawn_egg": "Uovo generatore di delfino",
  "item.minecraft.donkey_spawn_egg": "Uovo generatore di asino",
  "item.minecraft.dragon_breath": "Soffio di drago",
  "item.minecraft.dried_kelp": "Alga essiccata",
  "item.minecraft.drowned_spawn_egg": "Uovo generatore di annegato",
  "item.minecraft.dune_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornamento stile duna",
  "item.minecraft.echo_shard": "Scheggia di risonanza",
  "item.minecraft.egg": "Uovo",
  "item.minecraft.elder_guardian_spawn_egg": "Uovo generatore di guardiano antico",
  "item.minecraft.elytra": "Elitre",
  "item.minecraft.emerald": "Smeraldo",
  "item.minecraft.enchanted_book": "Libro incantato",
  "item.minecraft.enchanted_golden_apple": "Mela d'oro incantata",
  "item.minecraft.end_crystal": "Cristallo dell'End",
  "item.minecraft.ender_dragon_spawn_egg": "Uovo generatore di Enderdrago",
  "item.minecraft.ender_eye": "Occhio di ender",
  "item.minecraft.ender_pearl": "Perla di ender",
  "item.minecraft.enderman_spawn_egg": "Uovo generatore di enderman",
  "item.minecraft.endermite_spawn_egg": "Uovo generatore di endermite",
  "item.minecraft.evoker_spawn_egg": "Uovo generatore di evocatore",
  "item.minecraft.experience_bottle": "Ampolla d'esperienza",
  "item.minecraft.explorer_pottery_shard": "Coccio con mappa",
  "item.minecraft.explorer_pottery_sherd": "Coccio con mappa",
  "item.minecraft.eye_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornamento stile occhio",
  "item.minecraft.feather": "Piuma",
  "item.minecraft.fermented_spider_eye": "Occhio di ragno fermentato",
  "item.minecraft.field_masoned_banner_pattern": "Motivo con seminato di mattoni",
  "item.minecraft.filled_map": "Mappa",
  "item.minecraft.fire_charge": "Carica di fuoco",
  "item.minecraft.firework_rocket": "Razzo pirotecnico",
  "item.minecraft.firework_rocket.flight": "Durata del volo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Stella pirotecnica",
  "item.minecraft.firework_star.black": "Nero",
  "item.minecraft.firework_star.blue": "Blu",
  "item.minecraft.firework_star.brown": "Marrone",
  "item.minecraft.firework_star.custom_color": "Personalizzata",
  "item.minecraft.firework_star.cyan": "Ciano",
  "item.minecraft.firework_star.fade_to": "Sfuma in",
  "item.minecraft.firework_star.flicker": "Brillio",
  "item.minecraft.firework_star.gray": "Grigio",
  "item.minecraft.firework_star.green": "Verde",
  "item.minecraft.firework_star.light_blue": "Azzurro",
  "item.minecraft.firework_star.light_gray": "Grigio chiaro",
  "item.minecraft.firework_star.lime": "Lime",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Arancione",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Viola",
  "item.minecraft.firework_star.red": "Rosso",
  "item.minecraft.firework_star.shape": "Forma sconosciuta",
  "item.minecraft.firework_star.shape.burst": "Scoppio",
  "item.minecraft.firework_star.shape.creeper": "A forma di creeper",
  "item.minecraft.firework_star.shape.large_ball": "Sfera grande",
  "item.minecraft.firework_star.shape.small_ball": "Sfera piccola",
  "item.minecraft.firework_star.shape.star": "A forma di stella",
  "item.minecraft.firework_star.trail": "Scia",
  "item.minecraft.firework_star.white": "Bianco",
  "item.minecraft.firework_star.yellow": "Giallo",
  "item.minecraft.fishing_rod": "Canna da pesca",
  "item.minecraft.flint": "Selce",
  "item.minecraft.flint_and_steel": "Acciarino",
  "item.minecraft.flow_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornamento stile flusso",
  "item.minecraft.flow_banner_pattern": "Motivo per stendardo",
  "item.minecraft.flow_banner_pattern.desc": "Flusso",
  "item.minecraft.flow_banner_pattern.new": "Motivo con flusso",
  "item.minecraft.flow_pottery_sherd": "Coccio con flusso",
  "item.minecraft.flower_banner_pattern": "Motivo per stendardo",
  "item.minecraft.flower_banner_pattern.desc": "Fiore",
  "item.minecraft.flower_banner_pattern.new": "Motivo con fiore",
  "item.minecraft.flower_pot": "Vaso da fiori",
  "item.minecraft.fox_spawn_egg": "Uovo generatore di volpe",
  "item.minecraft.friend_pottery_shard": "Coccio con amico",
  "item.minecraft.friend_pottery_sherd": "Coccio con amico",
  "item.minecraft.frog_spawn_egg": "Uovo generatore di rana",
  "item.minecraft.furnace_minecart": "Vagonetto con fornace",
  "item.minecraft.ghast_spawn_egg": "Uovo generatore di ghast",
  "item.minecraft.ghast_tear": "Lacrima di ghast",
  "item.minecraft.glass_bottle": "Ampolla",
  "item.minecraft.glistering_melon_slice": "Fetta di anguria luccicante",
  "item.minecraft.globe_banner_pattern": "Motivo per stendardo",
  "item.minecraft.globe_banner_pattern.desc": "Globo",
  "item.minecraft.globe_banner_pattern.new": "Motivo con globo",
  "item.minecraft.glow_berries": "Bacche luminose",
  "item.minecraft.glow_ink_sac": "Sacca d'inchiostro luminescente",
  "item.minecraft.glow_item_frame": "Cornice luminescente",
  "item.minecraft.glow_squid_spawn_egg": "Uovo generatore di calamaro luminescente",
  "item.minecraft.glowstone_dust": "Polvere di luminite",
  "item.minecraft.goat_horn": "Corno di capra",
  "item.minecraft.goat_spawn_egg": "Uovo generatore di capra",
  "item.minecraft.gold_ingot": "Lingotto d'oro",
  "item.minecraft.gold_nugget": "Pepita d'oro",
  "item.minecraft.golden_apple": "Mela d'oro",
  "item.minecraft.golden_axe": "Ascia d'oro",
  "item.minecraft.golden_boots": "Stivali d'oro",
  "item.minecraft.golden_carrot": "Carota d'oro",
  "item.minecraft.golden_chestplate": "Corazza d'oro",
  "item.minecraft.golden_helmet": "Elmo d'oro",
  "item.minecraft.golden_hoe": "Zappa d'oro",
  "item.minecraft.golden_horse_armor": "Bardatura d'oro",
  "item.minecraft.golden_leggings": "Gambiere d'oro",
  "item.minecraft.golden_nautilus_armor": "Armatura d'oro per nautili",
  "item.minecraft.golden_pickaxe": "Piccone d'oro",
  "item.minecraft.golden_shovel": "Pala d'oro",
  "item.minecraft.golden_spear": "Lancia d'oro",
  "item.minecraft.golden_sword": "Spada d'oro",
  "item.minecraft.gray_bundle": "Sacchetto grigio",
  "item.minecraft.gray_dye": "Colorante grigio",
  "item.minecraft.gray_harness": "Imbracatura grigia",
  "item.minecraft.green_bundle": "Sacchetto verde",
  "item.minecraft.green_dye": "Colorante verde",
  "item.minecraft.green_harness": "Imbracatura verde",
  "item.minecraft.guardian_spawn_egg": "Uovo generatore di guardiano",
  "item.minecraft.gunpowder": "Polvere da sparo",
  "item.minecraft.guster_banner_pattern": "Motivo per stendardo",
  "item.minecraft.guster_banner_pattern.desc": "Raffica",
  "item.minecraft.guster_banner_pattern.new": "Motivo con raffica",
  "item.minecraft.guster_pottery_sherd": "Coccio con raffica",
  "item.minecraft.happy_ghast_spawn_egg": "Uovo generatore di ghast allegro",
  "item.minecraft.harness": "Imbracatura",
  "item.minecraft.heart_of_the_sea": "Cuore del mare",
  "item.minecraft.heart_pottery_shard": "Coccio con cuore",
  "item.minecraft.heart_pottery_sherd": "Coccio con cuore",
  "item.minecraft.heartbreak_pottery_shard": "Coccio con cuore spezzato",
  "item.minecraft.heartbreak_pottery_sherd": "Coccio con cuore spezzato",
  "item.minecraft.hoglin_spawn_egg": "Uovo generatore di hoglin",
  "item.minecraft.honey_bottle": "Ampolla di miele",
  "item.minecraft.honeycomb": "Favo",
  "item.minecraft.hopper_minecart": "Vagonetto con tramoggia",
  "item.minecraft.horse_spawn_egg": "Uovo generatore di cavallo",
  "item.minecraft.host_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornamento stile ospitante",
  "item.minecraft.howl_pottery_shard": "Coccio con ululato",
  "item.minecraft.howl_pottery_sherd": "Coccio con ululato",
  "item.minecraft.husk_spawn_egg": "Uovo generatore di mummificato",
  "item.minecraft.ink_sac": "Sacca d'inchiostro",
  "item.minecraft.iron_axe": "Ascia di ferro",
  "item.minecraft.iron_boots": "Stivali di ferro",
  "item.minecraft.iron_chestplate": "Corazza di ferro",
  "item.minecraft.iron_golem_spawn_egg": "Uovo generatore di golem di ferro",
  "item.minecraft.iron_helmet": "Elmo di ferro",
  "item.minecraft.iron_hoe": "Zappa di ferro",
  "item.minecraft.iron_horse_armor": "Bardatura di ferro",
  "item.minecraft.iron_ingot": "Lingotto di ferro",
  "item.minecraft.iron_leggings": "Gambiere di ferro",
  "item.minecraft.iron_nautilus_armor": "Armatura di ferro per nautili",
  "item.minecraft.iron_nugget": "Pepita di ferro",
  "item.minecraft.iron_pickaxe": "Piccone di ferro",
  "item.minecraft.iron_shovel": "Pala di ferro",
  "item.minecraft.iron_spear": "Lancia di ferro",
  "item.minecraft.iron_sword": "Spada di ferro",
  "item.minecraft.item_frame": "Cornice",
  "item.minecraft.jungle_boat": "Barca della giungla",
  "item.minecraft.jungle_chest_boat": "Barca della giungla con baule",
  "item.minecraft.knowledge_book": "Libro della conoscenza",
  "item.minecraft.lapis_lazuli": "Lapislazzuli",
  "item.minecraft.lava_bucket": "Secchio di lava",
  "item.minecraft.lead": "Guinzaglio",
  "item.minecraft.leather": "Cuoio",
  "item.minecraft.leather_boots": "Stivali di cuoio",
  "item.minecraft.leather_chestplate": "Giubba di cuoio",
  "item.minecraft.leather_helmet": "Casco di cuoio",
  "item.minecraft.leather_horse_armor": "Bardatura di cuoio",
  "item.minecraft.leather_leggings": "Pantaloni di cuoio",
  "item.minecraft.light_blue_bundle": "Sacchetto azzurro",
  "item.minecraft.light_blue_dye": "Colorante azzurro",
  "item.minecraft.light_blue_harness": "Imbracatura azzurra",
  "item.minecraft.light_gray_bundle": "Sacchetto grigio chiaro",
  "item.minecraft.light_gray_dye": "Colorante grigio chiaro",
  "item.minecraft.light_gray_harness": "Imbracatura grigio chiaro",
  "item.minecraft.lime_bundle": "Sacchetto lime",
  "item.minecraft.lime_dye": "Colorante lime",
  "item.minecraft.lime_harness": "Imbracatura lime",
  "item.minecraft.lingering_potion": "Pozione persistente",
  "item.minecraft.lingering_potion.effect.awkward": "Pozione strana persistente",
  "item.minecraft.lingering_potion.effect.empty": "Pozione persistente non fabbricabile",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Pozione persistente di resistenza al fuoco",
  "item.minecraft.lingering_potion.effect.harming": "Pozione persistente di danno",
  "item.minecraft.lingering_potion.effect.healing": "Pozione persistente di cura",
  "item.minecraft.lingering_potion.effect.infested": "Pozione persistente d'infestazione",
  "item.minecraft.lingering_potion.effect.invisibility": "Pozione persistente d'invisibilità",
  "item.minecraft.lingering_potion.effect.leaping": "Pozione persistente di salto",
  "item.minecraft.lingering_potion.effect.levitation": "Pozione persistente di levitazione",
  "item.minecraft.lingering_potion.effect.luck": "Pozione persistente di fortuna",
  "item.minecraft.lingering_potion.effect.mundane": "Pozione ordinaria persistente",
  "item.minecraft.lingering_potion.effect.night_vision": "Pozione persistente di visione notturna",
  "item.minecraft.lingering_potion.effect.oozing": "Pozione persistente di trasudazione",
  "item.minecraft.lingering_potion.effect.poison": "Pozione persistente di avvelenamento",
  "item.minecraft.lingering_potion.effect.regeneration": "Pozione persistente di rigenerazione",
  "item.minecraft.lingering_potion.effect.slow_falling": "Pozione persistente di caduta lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Pozione persistente di lentezza",
  "item.minecraft.lingering_potion.effect.strength": "Pozione persistente di forza",
  "item.minecraft.lingering_potion.effect.swiftness": "Pozione persistente di velocità",
  "item.minecraft.lingering_potion.effect.thick": "Pozione densa persistente",
  "item.minecraft.lingering_potion.effect.turtle_master": "Pozione persistente del maestro tartaruga",
  "item.minecraft.lingering_potion.effect.water": "Ampolla d'acqua persistente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Pozione persistente di apnea",
  "item.minecraft.lingering_potion.effect.weakness": "Pozione persistente di debolezza",
  "item.minecraft.lingering_potion.effect.weaving": "Pozione persistente di tessitura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Pozione persistente di carica ventosa",
  "item.minecraft.llama_spawn_egg": "Uovo generatore di lama",
  "item.minecraft.lodestone_compass": "Bussola magnetizzata",
  "item.minecraft.mace": "Mazza",
  "item.minecraft.magenta_bundle": "Sacchetto magenta",
  "item.minecraft.magenta_dye": "Colorante magenta",
  "item.minecraft.magenta_harness": "Imbracatura magenta",
  "item.minecraft.magma_cream": "Crema di magma",
  "item.minecraft.magma_cube_spawn_egg": "Uovo generatore di cubo di magma",
  "item.minecraft.mangrove_boat": "Barca di mangrovia",
  "item.minecraft.mangrove_chest_boat": "Barca di mangrovia con baule",
  "item.minecraft.map": "Mappa vuota",
  "item.minecraft.melon_seeds": "Semi di anguria",
  "item.minecraft.melon_slice": "Fetta di anguria",
  "item.minecraft.milk_bucket": "Secchio di latte",
  "item.minecraft.minecart": "Vagonetto",
  "item.minecraft.miner_pottery_shard": "Coccio con piccone",
  "item.minecraft.miner_pottery_sherd": "Coccio con piccone",
  "item.minecraft.mojang_banner_pattern": "Motivo per stendardo",
  "item.minecraft.mojang_banner_pattern.desc": "Logo",
  "item.minecraft.mojang_banner_pattern.new": "Motivo con logo",
  "item.minecraft.mooshroom_spawn_egg": "Uovo generatore di mooshroom",
  "item.minecraft.mourner_pottery_shard": "Coccio con lutto",
  "item.minecraft.mourner_pottery_sherd": "Coccio con lutto",
  "item.minecraft.mule_spawn_egg": "Uovo generatore di mulo",
  "item.minecraft.mushroom_stew": "Zuppa di funghi",
  "item.minecraft.music_disc_11": "Disco musicale",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Disco musicale",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Disco musicale",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Disco musicale",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Disco musicale",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Disco musicale",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Disco musicale",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco musicale",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (carillon)",
  "item.minecraft.music_disc_far": "Disco musicale",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Disco musicale",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco musicale",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Disco musicale",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Disco musicale",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Disco musicale",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Disco musicale",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Disco musicale",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Disco musicale",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Disco musicale",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Disco musicale",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Disco musicale",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Disco musicale",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Carne ovina cruda",
  "item.minecraft.name_tag": "Targhetta",
  "item.minecraft.nautilus_shell": "Conchiglia di nautilo",
  "item.minecraft.nautilus_spawn_egg": "Uovo generatore di nautilo",
  "item.minecraft.nether_brick": "Mattone del Nether",
  "item.minecraft.nether_star": "Stella del Nether",
  "item.minecraft.nether_wart": "Verruca del Nether",
  "item.minecraft.netherite_axe": "Ascia di netherite",
  "item.minecraft.netherite_boots": "Stivali di netherite",
  "item.minecraft.netherite_chestplate": "Corazza di netherite",
  "item.minecraft.netherite_helmet": "Elmo di netherite",
  "item.minecraft.netherite_hoe": "Zappa di netherite",
  "item.minecraft.netherite_horse_armor": "Bardatura di netherite",
  "item.minecraft.netherite_ingot": "Lingotto di netherite",
  "item.minecraft.netherite_leggings": "Gambiere di netherite",
  "item.minecraft.netherite_nautilus_armor": "Armatura di netherite per nautili",
  "item.minecraft.netherite_pickaxe": "Piccone di netherite",
  "item.minecraft.netherite_scrap": "Frammento di netherite",
  "item.minecraft.netherite_shovel": "Pala di netherite",
  "item.minecraft.netherite_spear": "Lancia di netherite",
  "item.minecraft.netherite_sword": "Spada di netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Schema di forgiatura",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Miglioramento di netherite",
  "item.minecraft.oak_boat": "Barca di quercia",
  "item.minecraft.oak_chest_boat": "Barca di quercia con baule",
  "item.minecraft.ocelot_spawn_egg": "Uovo generatore di ocelotto",
  "item.minecraft.ominous_bottle": "Ampolla infausta",
  "item.minecraft.ominous_trial_key": "Chiave della sfida infausta",
  "item.minecraft.orange_bundle": "Sacchetto arancione",
  "item.minecraft.orange_dye": "Colorante arancione",
  "item.minecraft.orange_harness": "Imbracatura arancione",
  "item.minecraft.painting": "Quadro",
  "item.minecraft.pale_oak_boat": "Barca di quercia pallida",
  "item.minecraft.pale_oak_chest_boat": "Barca di quercia pallida con baule",
  "item.minecraft.panda_spawn_egg": "Uovo generatore di panda",
  "item.minecraft.paper": "Carta",
  "item.minecraft.parched_spawn_egg": "Uovo generatore di ossecco",
  "item.minecraft.parrot_spawn_egg": "Uovo generatore di pappagallo",
  "item.minecraft.phantom_membrane": "Membrana di fantasma",
  "item.minecraft.phantom_spawn_egg": "Uovo generatore di fantasma",
  "item.minecraft.pig_spawn_egg": "Uovo generatore di maiale",
  "item.minecraft.piglin_banner_pattern": "Motivo per stendardo",
  "item.minecraft.piglin_banner_pattern.desc": "Grugno",
  "item.minecraft.piglin_banner_pattern.new": "Motivo con grugno",
  "item.minecraft.piglin_brute_spawn_egg": "Uovo generatore di piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Uovo generatore di piglin",
  "item.minecraft.pillager_spawn_egg": "Uovo generatore di predone",
  "item.minecraft.pink_bundle": "Sacchetto rosa",
  "item.minecraft.pink_dye": "Colorante rosa",
  "item.minecraft.pink_harness": "Imbracatura rosa",
  "item.minecraft.pitcher_plant": "Pianta carnivora",
  "item.minecraft.pitcher_pod": "Baccello di pianta carnivora",
  "item.minecraft.plenty_pottery_shard": "Coccio con ricchezze",
  "item.minecraft.plenty_pottery_sherd": "Coccio con ricchezze",
  "item.minecraft.poisonous_potato": "Patata velenosa",
  "item.minecraft.polar_bear_spawn_egg": "Uovo generatore di orso polare",
  "item.minecraft.popped_chorus_fruit": "Frutto del coro scoppiato",
  "item.minecraft.porkchop": "Costoletta di maiale cruda",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Pozione",
  "item.minecraft.potion.effect.awkward": "Pozione strana",
  "item.minecraft.potion.effect.empty": "Pozione non fabbricabile",
  "item.minecraft.potion.effect.fire_resistance": "Pozione di resistenza al fuoco",
  "item.minecraft.potion.effect.harming": "Pozione di danno",
  "item.minecraft.potion.effect.healing": "Pozione di cura",
  "item.minecraft.potion.effect.infested": "Pozione d'infestazione",
  "item.minecraft.potion.effect.invisibility": "Pozione d'invisibilità",
  "item.minecraft.potion.effect.leaping": "Pozione di salto",
  "item.minecraft.potion.effect.levitation": "Pozione di levitazione",
  "item.minecraft.potion.effect.luck": "Pozione di fortuna",
  "item.minecraft.potion.effect.mundane": "Pozione ordinaria",
  "item.minecraft.potion.effect.night_vision": "Pozione di visione notturna",
  "item.minecraft.potion.effect.oozing": "Pozione di trasudazione",
  "item.minecraft.potion.effect.poison": "Pozione di avvelenamento",
  "item.minecraft.potion.effect.regeneration": "Pozione di rigenerazione",
  "item.minecraft.potion.effect.slow_falling": "Pozione di caduta lenta",
  "item.minecraft.potion.effect.slowness": "Pozione di lentezza",
  "item.minecraft.potion.effect.strength": "Pozione di forza",
  "item.minecraft.potion.effect.swiftness": "Pozione di velocità",
  "item.minecraft.potion.effect.thick": "Pozione densa",
  "item.minecraft.potion.effect.turtle_master": "Pozione del maestro tartaruga",
  "item.minecraft.potion.effect.water": "Ampolla d'acqua",
  "item.minecraft.potion.effect.water_breathing": "Pozione di apnea",
  "item.minecraft.potion.effect.weakness": "Pozione di debolezza",
  "item.minecraft.potion.effect.weaving": "Pozione di tessitura",
  "item.minecraft.potion.effect.wind_charged": "Pozione di carica ventosa",
  "item.minecraft.pottery_shard_archer": "Coccio con arco e freccia",
  "item.minecraft.pottery_shard_arms_up": "Coccio con alzata di braccia",
  "item.minecraft.pottery_shard_prize": "Coccio con premio",
  "item.minecraft.pottery_shard_skull": "Coccio con teschio",
  "item.minecraft.powder_snow_bucket": "Secchio di neve polverosa",
  "item.minecraft.prismarine_crystals": "Cristalli di prismarino",
  "item.minecraft.prismarine_shard": "Scheggia di prismarino",
  "item.minecraft.prize_pottery_shard": "Coccio con premio",
  "item.minecraft.prize_pottery_sherd": "Coccio con premio",
  "item.minecraft.pufferfish": "Pesce palla",
  "item.minecraft.pufferfish_bucket": "Secchio con pesce palla",
  "item.minecraft.pufferfish_spawn_egg": "Uovo generatore di pesce palla",
  "item.minecraft.pumpkin_pie": "Torta di zucca",
  "item.minecraft.pumpkin_seeds": "Semi di zucca",
  "item.minecraft.purple_bundle": "Sacchetto viola",
  "item.minecraft.purple_dye": "Colorante viola",
  "item.minecraft.purple_harness": "Imbracatura viola",
  "item.minecraft.quartz": "Quarzo del Nether",
  "item.minecraft.rabbit": "Coniglio crudo",
  "item.minecraft.rabbit_foot": "Zampa di coniglio",
  "item.minecraft.rabbit_hide": "Pelle di coniglio",
  "item.minecraft.rabbit_spawn_egg": "Uovo generatore di coniglio",
  "item.minecraft.rabbit_stew": "Stufato di coniglio",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornamento stile allevatore",
  "item.minecraft.ravager_spawn_egg": "Uovo generatore di devastatore",
  "item.minecraft.raw_copper": "Rame grezzo",
  "item.minecraft.raw_gold": "Oro grezzo",
  "item.minecraft.raw_iron": "Ferro grezzo",
  "item.minecraft.recovery_compass": "Bussola del recupero",
  "item.minecraft.red_bundle": "Sacchetto rosso",
  "item.minecraft.red_dye": "Colorante rosso",
  "item.minecraft.red_harness": "Imbracatura rossa",
  "item.minecraft.redstone": "Polvere di redstone",
  "item.minecraft.resin_brick": "Mattone di resina",
  "item.minecraft.resin_clump": "Grumo di resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornamento stile costole",
  "item.minecraft.rotten_flesh": "Carne marcia",
  "item.minecraft.saddle": "Sella",
  "item.minecraft.salmon": "Salmone crudo",
  "item.minecraft.salmon_bucket": "Secchio con salmone",
  "item.minecraft.salmon_spawn_egg": "Uovo generatore di salmone",
  "item.minecraft.scrape_pottery_sherd": "Coccio con raschiatura",
  "item.minecraft.scute": "Scuto",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornamento stile sentinella",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornamento stile modellatore",
  "item.minecraft.sheaf_pottery_shard": "Coccio con covone",
  "item.minecraft.sheaf_pottery_sherd": "Coccio con covone",
  "item.minecraft.shears": "Cesoie",
  "item.minecraft.sheep_spawn_egg": "Uovo generatore di pecora",
  "item.minecraft.shelter_pottery_shard": "Coccio con riparo",
  "item.minecraft.shelter_pottery_sherd": "Coccio con riparo",
  "item.minecraft.shield": "Scudo",
  "item.minecraft.shield.black": "Scudo nero",
  "item.minecraft.shield.blue": "Scudo blu",
  "item.minecraft.shield.brown": "Scudo marrone",
  "item.minecraft.shield.cyan": "Scudo ciano",
  "item.minecraft.shield.gray": "Scudo grigio",
  "item.minecraft.shield.green": "Scudo verde",
  "item.minecraft.shield.light_blue": "Scudo azzurro",
  "item.minecraft.shield.light_gray": "Scudo grigio chiaro",
  "item.minecraft.shield.lime": "Scudo lime",
  "item.minecraft.shield.magenta": "Scudo magenta",
  "item.minecraft.shield.orange": "Scudo arancione",
  "item.minecraft.shield.pink": "Scudo rosa",
  "item.minecraft.shield.purple": "Scudo viola",
  "item.minecraft.shield.red": "Scudo rosso",
  "item.minecraft.shield.white": "Scudo bianco",
  "item.minecraft.shield.yellow": "Scudo giallo",
  "item.minecraft.shulker_shell": "Guscio di shulker",
  "item.minecraft.shulker_spawn_egg": "Uovo generatore di shulker",
  "item.minecraft.sign": "Cartello",
  "item.minecraft.silence_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornamento stile silenzio",
  "item.minecraft.silverfish_spawn_egg": "Uovo generatore di pesciolino d'argento",
  "item.minecraft.skeleton_horse_spawn_egg": "Uovo generatore di cavallo scheletro",
  "item.minecraft.skeleton_spawn_egg": "Uovo generatore di scheletro",
  "item.minecraft.skull_banner_pattern": "Motivo per stendardo",
  "item.minecraft.skull_banner_pattern.desc": "Teschio",
  "item.minecraft.skull_banner_pattern.new": "Motivo con teschio",
  "item.minecraft.skull_pottery_shard": "Coccio con teschio",
  "item.minecraft.skull_pottery_sherd": "Coccio con teschio",
  "item.minecraft.slime_ball": "Palla di gelatina",
  "item.minecraft.slime_spawn_egg": "Uovo generatore di gelatina",
  "item.minecraft.smithing_template": "Schema di forgiatura",
  "item.minecraft.smithing_template.applies_to": "Si applica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Inserisci un lingotto o un cristallo",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armatura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Inserisci un pezzo d'armatura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotti e cristalli",
  "item.minecraft.smithing_template.ingredients": "Ingredienti:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Inserisci un lingotto di netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipaggiamento di diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Inserisci un attrezzo, arma o armatura di diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingotto di netherite",
  "item.minecraft.smithing_template.upgrade": "Miglioramento: ",
  "item.minecraft.sniffer_spawn_egg": "Uovo generatore di fiutatore",
  "item.minecraft.snort_pottery_shard": "Coccio con fiutatore",
  "item.minecraft.snort_pottery_sherd": "Coccio con fiutatore",
  "item.minecraft.snout_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornamento stile grugno",
  "item.minecraft.snow_golem_spawn_egg": "Uovo generatore di golem di neve",
  "item.minecraft.snowball": "Palla di neve",
  "item.minecraft.spectral_arrow": "Freccia spettrale",
  "item.minecraft.spider_eye": "Occhio di ragno",
  "item.minecraft.spider_spawn_egg": "Uovo generatore di ragno",
  "item.minecraft.spire_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornamento stile guglie",
  "item.minecraft.splash_potion": "Pozione da lancio",
  "item.minecraft.splash_potion.effect.awkward": "Pozione strana da lancio",
  "item.minecraft.splash_potion.effect.empty": "Pozione da lancio non fabbricabile",
  "item.minecraft.splash_potion.effect.fire_resistance": "Pozione da lancio di resistenza al fuoco",
  "item.minecraft.splash_potion.effect.harming": "Pozione da lancio di danno",
  "item.minecraft.splash_potion.effect.healing": "Pozione da lancio di cura",
  "item.minecraft.splash_potion.effect.infested": "Pozione da lancio d'infestazione",
  "item.minecraft.splash_potion.effect.invisibility": "Pozione da lancio d'invisibilità",
  "item.minecraft.splash_potion.effect.leaping": "Pozione da lancio di salto",
  "item.minecraft.splash_potion.effect.levitation": "Pozione da lancio di levitazione",
  "item.minecraft.splash_potion.effect.luck": "Pozione da lancio di fortuna",
  "item.minecraft.splash_potion.effect.mundane": "Pozione ordinaria da lancio",
  "item.minecraft.splash_potion.effect.night_vision": "Pozione da lancio di visione notturna",
  "item.minecraft.splash_potion.effect.oozing": "Pozione da lancio di trasudazione",
  "item.minecraft.splash_potion.effect.poison": "Pozione da lancio di avvelenamento",
  "item.minecraft.splash_potion.effect.regeneration": "Pozione da lancio di rigenerazione",
  "item.minecraft.splash_potion.effect.slow_falling": "Pozione da lancio di caduta lenta",
  "item.minecraft.splash_potion.effect.slowness": "Pozione da lancio di lentezza",
  "item.minecraft.splash_potion.effect.strength": "Pozione da lancio di forza",
  "item.minecraft.splash_potion.effect.swiftness": "Pozione da lancio di velocità",
  "item.minecraft.splash_potion.effect.thick": "Pozione densa da lancio",
  "item.minecraft.splash_potion.effect.turtle_master": "Pozione da lancio del maestro tartaruga",
  "item.minecraft.splash_potion.effect.water": "Ampolla d'acqua da lancio",
  "item.minecraft.splash_potion.effect.water_breathing": "Pozione da lancio di apnea",
  "item.minecraft.splash_potion.effect.weakness": "Pozione da lancio di debolezza",
  "item.minecraft.splash_potion.effect.weaving": "Pozione da lancio di tessitura",
  "item.minecraft.splash_potion.effect.wind_charged": "Pozione da lancio di carica ventosa",
  "item.minecraft.spruce_boat": "Barca di abete",
  "item.minecraft.spruce_chest_boat": "Barca di abete con baule",
  "item.minecraft.spyglass": "Cannocchiale",
  "item.minecraft.squid_spawn_egg": "Uovo generatore di calamaro",
  "item.minecraft.stick": "Bastone",
  "item.minecraft.stone_axe": "Ascia di pietra",
  "item.minecraft.stone_hoe": "Zappa di pietra",
  "item.minecraft.stone_pickaxe": "Piccone di pietra",
  "item.minecraft.stone_shovel": "Pala di pietra",
  "item.minecraft.stone_spear": "Lancia di pietra",
  "item.minecraft.stone_sword": "Spada di pietra",
  "item.minecraft.stray_spawn_egg": "Uovo generatore di errante",
  "item.minecraft.strider_spawn_egg": "Uovo generatore di strider",
  "item.minecraft.string": "Cordicella",
  "item.minecraft.sugar": "Zucchero",
  "item.minecraft.suspicious_stew": "Zuppa sospetta",
  "item.minecraft.sweet_berries": "Bacche dolci",
  "item.minecraft.tadpole_bucket": "Secchio con girino",
  "item.minecraft.tadpole_spawn_egg": "Uovo generatore di girino",
  "item.minecraft.tide_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornamento stile marea",
  "item.minecraft.tipped_arrow": "Freccia imbevuta",
  "item.minecraft.tipped_arrow.effect.awkward": "Freccia imbevuta",
  "item.minecraft.tipped_arrow.effect.empty": "Freccia imbevuta non fabbricabile",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Freccia di resistenza al fuoco",
  "item.minecraft.tipped_arrow.effect.harming": "Freccia di danno",
  "item.minecraft.tipped_arrow.effect.healing": "Freccia di cura",
  "item.minecraft.tipped_arrow.effect.infested": "Freccia d'infestazione",
  "item.minecraft.tipped_arrow.effect.invisibility": "Freccia d'invisibilità",
  "item.minecraft.tipped_arrow.effect.leaping": "Freccia di salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Freccia di levitazione",
  "item.minecraft.tipped_arrow.effect.luck": "Freccia di fortuna",
  "item.minecraft.tipped_arrow.effect.mundane": "Freccia imbevuta",
  "item.minecraft.tipped_arrow.effect.night_vision": "Freccia di visione notturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Freccia di trasudazione",
  "item.minecraft.tipped_arrow.effect.poison": "Freccia di avvelenamento",
  "item.minecraft.tipped_arrow.effect.regeneration": "Freccia di rigenerazione",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Freccia di caduta lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Freccia di lentezza",
  "item.minecraft.tipped_arrow.effect.strength": "Freccia di forza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Freccia di velocità",
  "item.minecraft.tipped_arrow.effect.thick": "Freccia imbevuta",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Freccia del maestro tartaruga",
  "item.minecraft.tipped_arrow.effect.water": "Freccia d'acqua",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Freccia di apnea",
  "item.minecraft.tipped_arrow.effect.weakness": "Freccia di debolezza",
  "item.minecraft.tipped_arrow.effect.weaving": "Freccia di tessitura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Freccia di carica ventosa",
  "item.minecraft.tnt_minecart": "Vagonetto con TNT",
  "item.minecraft.torchflower_seeds": "Semi di fiortorcia",
  "item.minecraft.totem_of_undying": "Totem dell'immortalità",
  "item.minecraft.trader_llama_spawn_egg": "Uovo generatore di lama di mercante",
  "item.minecraft.trial_key": "Chiave della sfida",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Pesce tropicale",
  "item.minecraft.tropical_fish_bucket": "Secchio con pesce tropicale",
  "item.minecraft.tropical_fish_spawn_egg": "Uovo generatore di pesce tropicale",
  "item.minecraft.turtle_helmet": "Carapace di tartaruga",
  "item.minecraft.turtle_scute": "Scuto di tartaruga",
  "item.minecraft.turtle_spawn_egg": "Uovo generatore di tartaruga",
  "item.minecraft.vex_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornamento stile vessante",
  "item.minecraft.vex_spawn_egg": "Uovo generatore di vessante",
  "item.minecraft.villager_spawn_egg": "Uovo generatore di villico",
  "item.minecraft.vindicator_spawn_egg": "Uovo generatore di vendicatore",
  "item.minecraft.wandering_trader_spawn_egg": "Uovo generatore di mercante ambulante",
  "item.minecraft.ward_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornamento stile sorvegliante",
  "item.minecraft.warden_spawn_egg": "Uovo generatore di sorvegliante",
  "item.minecraft.warped_fungus_on_a_stick": "Bastone e fungo distorto",
  "item.minecraft.water_bucket": "Secchio d'acqua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornamento stile ricognitore",
  "item.minecraft.wheat": "Grano",
  "item.minecraft.wheat_seeds": "Semi di grano",
  "item.minecraft.white_bundle": "Sacchetto bianco",
  "item.minecraft.white_dye": "Colorante bianco",
  "item.minecraft.white_harness": "Imbracatura bianca",
  "item.minecraft.wild_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornamento stile selvaggio",
  "item.minecraft.wind_charge": "Carica di vento",
  "item.minecraft.witch_spawn_egg": "Uovo generatore di strega",
  "item.minecraft.wither_skeleton_spawn_egg": "Uovo generatore di scheletro di Wither",
  "item.minecraft.wither_spawn_egg": "Uovo generatore di Wither",
  "item.minecraft.wolf_armor": "Armatura per lupi",
  "item.minecraft.wolf_spawn_egg": "Uovo generatore di lupo",
  "item.minecraft.wooden_axe": "Ascia di legno",
  "item.minecraft.wooden_hoe": "Zappa di legno",
  "item.minecraft.wooden_pickaxe": "Piccone di legno",
  "item.minecraft.wooden_shovel": "Pala di legno",
  "item.minecraft.wooden_spear": "Lancia di legno",
  "item.minecraft.wooden_sword": "Spada di legno",
  "item.minecraft.writable_book": "Libro e penna",
  "item.minecraft.written_book": "Libro scritto",
  "item.minecraft.yellow_bundle": "Sacchetto giallo",
  "item.minecraft.yellow_dye": "Colorante giallo",
  "item.minecraft.yellow_harness": "Imbracatura gialla",
  "item.minecraft.zoglin_spawn_egg": "Uovo generatore di zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Uovo generatore di cavallo zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Uovo generatore di nautilo zombi",
  "item.minecraft.zombie_spawn_egg": "Uovo generatore di zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Uovo generatore di villico zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Uovo generatore di piglin zombificato"
}
export const it_it = items; 
